import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearUserProfile } from '../redux/actions/user';
import { clearBugsnagUser } from '../redux/actions/bugsnag';
import { setRedirectUri } from '../redux/actions/auth';
import { event } from '../redux/actions/google';
import RouteTitle from './RouteTitle';
import EditSectionLabel from './EditSectionLabel';
import EditSectionInput from './EditSectionInput';
import EditSectionDropdown from './EditSectionDropdown';
import EditSectionLinkedDropdown from './EditSectionLinkedDropdown';
import EditSectionTextArea from './EditSectionTextArea';
import EditSectionDateTime from './EditSectionDateTime';
import SelectionDropdownButton from './SelectionDropdownButton';
import Select from 'react-select';
import MultiInput from './MultiInput';
import FileUpload from './FileUpload';
import RadioSelection from './RadioSelection';
import Pagination from './Pagination';
import EtelAPI from '../api/EtelAPI';
import LeadgenFileDialog from './LeadgenFileDialog';
import ProgramDialog from './ProgramDialog';
import EditSectionCheckBox  from './EditSectionCheckBox';
import { ProgramTabContainer, ProgramTabPanel, ProgramTabPanelItem } from './ProgramTabContainer';
import Loadable from 'react-loadable';
import Overlay from './Overlay';
import DeleteItemDialog from './DeleteItemDialog';
import ChildRowsDialog from './ChildRowsDialog';
import InputDialog from './InputDialog';
import PageSizeSelector from './PageSizeSelector';
import PagePositionLabel from './PagePositionLabel';
import clone from 'clone';
import moment from 'moment';
import Alerts from '../prototypes/Alerts';
import ListExport from './ListExport';
import EditLayoutDropdown from './EditLayoutDropdown';
import EditSectionLinkedField from './EditSectionLinkedField';
import BatchDeleteDialog from './BatchDeleteDialog';
import FileUploadDialog from './FileUploadDialog';

const LoadableListExportDialog = Loadable( {
  loader: () => import( /* webpackChunkName: "LoadableListExportDialog" */ './ListExportDialog' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableProgramInputs = Loadable( {
  loader: () => import( /* webpackChunkName: "LoadableProgramInputs" */ './ProgramInputs' ),
  loading: () => <div> LOADING </div>,
} );


const LoadableListGrid = Loadable( {
  loader: () => import( /* webpackChunkName: "LoadableListGrid" */ './ListGrid' ),
  loading: () => <div> LOADING </div>,
} );


const LoadableListFilter = Loadable( {
  loader: () => import( /* webpackChunkName: "LoadableListFilter" */ './ListFilter' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableListSearch = Loadable( {
  loader: () => import( /* webpackChunkName: "LoadableListSearch" */ './ListSearch' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableListGridEditor = Loadable( {
  loader: () => import( /* webpackChunkName: "ListGridEditor" */ './ListGridEditor' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableProgramFeesForm = Loadable( {
  loader: () => import( /* webpackChunkName: "ProgramFeesFormChunk" */ './ProgramFeesForm' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableGroupSettingsForm = Loadable( {
  loader: () => import( /* webpackChunkName: "GroupSettingsChunk" */ './GroupSettingsForm' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableWijmoOnOffNet = Loadable( {
  loader: () => import( /* webpackChunkName: "WijmoOnOffNetChunk" */ './WijmoOnOffNet' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableVoiceFilesForm = Loadable( {
  loader: () => import( /* webpackChunkName: "VoicefilesFormChunk" */ './ProgramVoiceFilesForm' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableScheduleForm = Loadable( {
  loader: () => import( /* webpackChunkName: "ScheduleFormChunk" */ './ScheduleForm' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableProgramHistory= Loadable( {
  loader: () => import( /* webpackChunkName: "ProgramHistoryChunk" */ './ProgramHistory' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableProgramLinks= Loadable( {
  loader: () => import( /* webpackChunkName: "ProgramLinksChunk" */ './ProgramLinks' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableASRInteractions= Loadable( {
  loader: () => import( /* webpackChunkName: "ProgramASRInteractionsChunk" */ './ASRInteractions' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableASRDialoutNumbers= Loadable( {
  loader: () => import( /* webpackChunkName: "ProgramASRDialoutNumbersChunk" */ './ASRDialoutNumbers' ),
  loading: () => <div> LOADING </div>,
} );

const LoadableProgramDynamicStatements= Loadable( {
  loader: () => import( /* webpackChunkName: "ProgramDynamicStatementsChunk" */ './ProgramDynamicStatements' ),
  loading: () => <div> LOADING </div>,
} );


// The real OG, now with mount checking before setting the state
class ListContainer extends React.Component {
  constructor( props ){
    super( props );
    this.default_layout = {
      'newbutton':{
        'caption':'Item',
        'is_custom': 'None' // This is a not a custom component
      },
      'tabs': [],
      'section':{
        'title':'Item',
        'endpoint': 'endpoint',
        'cancreate': false,
        'canedit': false,
        'rowkey':'rowkey',
        'newitem':{
        },
      },
      'headers': [],
      'fields': [],
      'filters': []
    };

    this.state = {
      /* properties that are dynamic and can change from parent */
      id: this.props.id === undefined ? 'ListContainer' : this.props.id,
      layout: this.props.layout === undefined ? this.default_layout : this.props.layout,
      layouts: props.layouts === undefined ? [] : props.layouts,
      selectedtab: this.props.selectedtab === undefined ? 0 : this.props.selectedtab,
      /* properties managed locally to the component */
      loading: false,
      pageindex: 0,
      pagesize: 50,
      pagestart: 1,
      pageend: 50,
      pagetotal: 0,
      search: '',
      allrows: [],
      rows: [],
      searchfilters: {},
      filtered: false,
      filteredrows: [],
      filteredcount: 0,
      allrowshash: {},
      optionstore: {},
      filterstore: {},
      currentitem: {},
      processes: {},
      showdetailview: false,
      showdeletedialog: false,
      showinputdialog: false,
      showsavedialog: false,
      showexportdialog: false,
      showfilters: false,
      showbatchdeletedialog: false,
      allowsaveandcontinue: false,
      detailviewmode: '',
      dialogtitle: '',
      showgriddialog: false,
      insertcomplete: false,
      updatecomplete: false,
      fileuploadcomplete: false,
      fileuploadstatus: {'TOTAL_COUNT':0},
      filecountsuccess: 0,
      filecountfailure: 0,
      filecheck: false,
      gridtitle:'',
      gridrows: [],
      gridoptions: {},
      gridnewitem: {'title':'[title here]'},
      filters: [],
      showfileuploaddialog: false,
      dialogMode: '',
      // Custom Modal for Programs
      showProgramsDialog: false,
      // Multiple layout
      multilayout: this.props.layout.section.multilayout === undefined ? false : this.props.layout.section.multilayout,
      layoutkey: undefined,
      layoutoptions: this.props.layout.section.layouts === undefined ? [] : this.props.layout.section.layouts,
      layoutselection: undefined,
      // Search variables
      prev_filteredlength: 0,
      // Linked dropdown options for pgm_voicefiles
      pgm_voicefiles_linkedoptions: [],
      // Programs / Settings variables
      currentProgramTab: 0,
      expandProgramSettings: false,
      ONOFFNET_PGM_MAIN_ID: -1,
      pgmgroupsavetrigger: false,
      linkedtriggers: [],

      // Event driven render values
      render_grid_view_body_height: 740,
      voicefiles: [],

      //File Upload Information
      defdnis: '',
      uploadfiles:{0:[], 1:[], 2:[]},
      allfiles: [],
      description: '',
      newallfiles: [],
      trueuploadfiles: {0:[], 1:[], 2:[]},
    };

    // Bindings
    this.onNewItem = this.onNewItem.bind( this );
    this.onCancelDelete = this.onCancelDelete.bind( this );
    this.onConfirmDelete = this.onConfirmDelete.bind( this );
    this.saveSubItem = this.saveSubItem.bind( this );
    this.onFilterFieldChanged = this.onFilterFieldChanged.bind( this );
    this.onSaveItemFromPrograms = this.onSaveItemFromPrograms.bind( this );
    this.onCloseItemFromPrograms = this.onCloseItemFromPrograms.bind( this );
    this.onChangedProgramsTab = this.onChangedProgramsTab.bind( this );
    this.updatePGMVoiceOptions = this.updatePGMVoiceOptions.bind( this );
    this.onShowFilter = this.onShowFilter.bind( this );
    this.onFilterSearch = this.onFilterSearch.bind( this );
    this.onDropFileUpload = this.onDropFileUpload.bind( this );
    this.onPageSizeChanged = this.onPageSizeChanged.bind( this );
    this.onSearchChanged = this.onSearchChanged.bind( this );
    this.onPageChanged = this.onPageChanged.bind( this );
    this.onCancelItem = this.onCancelItem.bind( this );
    this.onSaveItem = this.onSaveItem.bind( this );
    this.onSaveAndContinue = this.onSaveAndContinue.bind( this );
    this.onDeleteItem = this.onDeleteItem.bind( this );
    this.onEndDateTime = this.onEndDateTime.bind( this );
    this.onShowSaveDialog = this.onShowSaveDialog.bind( this );
    this.onCancelDelete = this.onCancelDelete.bind( this );
    this.onConfirmDelete = this.onConfirmDelete.bind( this );
    this.onNewSubItem = this.onNewSubItem.bind( this );
    this.onChangeSubItem = this.onChangeSubItem.bind( this );
    this.onDeleteSubItem = this.onDeleteSubItem.bind( this );
    this.onCancelGrid = this.onCancelGrid.bind( this );
    this.onSaveGrid = this.onSaveGrid.bind( this );
    this.onHideInputDialog = this.onHideInputDialog.bind( this );
    this.onHideSaveDialog = this.onHideSaveDialog.bind( this );
    this.onEditItem = this.onEditItem.bind( this );
    this.onInsertItem = this.onInsertItem.bind( this );
    this.onUpdateItem = this.onUpdateItem.bind( this );
    this.onChangeLayoutEvent = this.onChangeLayoutEvent.bind( this );
    this.ProgramCopyNew = this.ProgramCopyNew.bind( this );
    this.onExport = this.onExport.bind( this );
    this.onCloseExportDialog = this.onCloseExportDialog.bind( this );
    this.buildTriggers = this.buildTriggers.bind( this );
    this.buildListRows = this.buildListRows.bind( this );
    this.onBatchDelete = this.onBatchDelete.bind( this );
    this.onBatchDeleteConfirm = this.onBatchDeleteConfirm.bind( this );
    this.onBatchDeleteError = this.onBatchDeleteError.bind( this );
    this.onCloseBatchDelete = this.onCloseBatchDelete.bind( this );
    this.windowResizeReRender = this.windowResizeReRender.bind( this );
    this.onShowFileUploadDialog = this.onShowFileUploadDialog.bind( this );
    this.onHideFileUploadDialog = this.onHideFileUploadDialog.bind( this );
    this.onFileDialogConfirm = this.onFileDialogConfirm.bind( this );
    this.onCancelItemChangeFromDialog = this.onCancelItemChangeFromDialog.bind( this );

    // Parent Events Passed up
    this.onDialogInsert = this.onDialogInsert.bind( this );
    this.onDialogUpdate = this.onDialogUpdate.bind( this );
    this.onDialogDelete = this.onDialogDelete.bind( this );
    this.onLoadRowsFromDialog = this.onLoadRowsFromDialog.bind( this );
    this.onDataSourceChanged = this.onDataSourceChanged.bind( this );
    this.onFormatReadOnlyCellLabel = this.onFormatReadOnlyCellLabel.bind( this );
    this.onIconClicked = this.onIconClicked.bind( this );
    this.onParentForceRowReload = this.onParentForceRowReload.bind( this );

    // Check before rending
    this._ismounted = false;
  }

  // React Component Events
  componentDidMount( ) {
    const layout = this.state.layout;
    const filters = layout.filters;
    this._ismounted = true;

    // Build the Option Store that will be
    // used for dropdowns in edit detial
    // section
    this.buildOptionStore();

    // Build the Filter Store that will be
    // used for dropdowns in advanced search
    this.buildFilterStore();

    // Build the default filter for the ListGrid Filter
    let defaultFilters = {};
    if( filters !== undefined ) {
      if( filters.length > 0 ) {
        for( let filterIndex = 0; filterIndex < filters.length; filterIndex++ ) {
          const filter = filters[ filterIndex ];
          const defaultColumn = filter.paramName;
          const defaultValue = filter.default;

          if( defaultColumn !== undefined && defaultValue !== undefined ) {
            defaultFilters[ defaultColumn ] = defaultValue;
          }
        }
      }
    }

    // Build the rows for ListGrid
    this.buildListRows( defaultFilters );

    // Build the triggers
    this.buildTriggers();

    if( this.state.multilayout === true ){
      if( this.state.layoutkey === undefined ){
        const layoutoptions = this.state.layoutoptions;
        if( layoutoptions !== 0 ){

          this.setState( {
            layoutkey: layoutoptions[0]['key']
          } );

          // Dynamic layout
          this.buildOptionStoreByValue( layoutoptions[0]['layout']['section'] );
        }
      }
    }

    // Dynamic event bindings (add them here)
    window.addEventListener( 'resize', this.windowResizeReRender, false );

    // Functions/Methods called after the component mounts
    this.windowResizeReRender();
  }


  // Component props passed down
  componentWillReceiveProps( nextProps ) {
    if( this._ismounted === true ){
      const layout = this.state.layout;
      const section = layout.section;
      const rowkey = section.rowkey;
      const showProgramsDialog = nextProps.showProgramsDialog === undefined ? false : nextProps.showProgramsDialog;
      const currentProgramTab = nextProps.currentProgramTab === undefined ? 0 : nextProps.currentProgramTab;
      const currentitem = nextProps.row === undefined ? {} : nextProps.row;
      let detailviewmode = '';
      let newallrows = this.state.allrows;
      let newfilteredrows = this.state.filteredrows;

      this.buildListRows( this.state.searchfilters );

      if( nextProps.row !== undefined ) {

        newallrows = this.state.allrows.map( ( row ) => {
          if( row[ rowkey ] === nextProps.row[ rowkey ] ) {
            return nextProps.row;
          } else {
            return row;
          }
        } );

        if( this.state.filtered === true ) {
          newfilteredrows = this.state.filteredrows.map( ( filteredrow ) => {
            if( filteredrow[ rowkey ] === nextProps.row[ rowkey ] ) {
              return nextProps.row;
            } else {
              return filteredrow;
            }
          } );
        }
      }

      if ( showProgramsDialog ) {
        detailviewmode = 'EDIT';
      }

      this.setState( {
        id: nextProps.id,
        allrows: newallrows,
        filteredrows: newfilteredrows,
        selectedtab: nextProps.selectedtab === undefined ? 0 : nextProps.selectedtab,
        detailviewmode: detailviewmode,
        showProgramsDialog: showProgramsDialog,
        currentProgramTab: currentProgramTab,
        currentitem: currentitem,
        layouts: nextProps.layouts === undefined ? [] : nextProps.layouts,
        loading: false
      } );
    }
  }

  // Removes bindings to element that are not needed once the component is gone
  componentWillUnmount() {
    window.removeEventListener( 'resize', this.windowResizeReRender );
    this._ismounted = false;
  }

  // Add to this function if you need this component to re-render
  // on screen size changed (dependent on client width x height)
  windowResizeReRender(){
    // Dynamic rendering of the grid body to always fit properly
    let grid_view_body = document.getElementsByClassName( 'grid-view-body' )[0]; // Element size we want
    let advance_view = document.getElementsByClassName( 'list-filter' )[0];
    let grid_view_tabs = document.getElementsByClassName( 'grid-view-tabs' )[0];
    let advance_view_size = 0;

    // Getting the size of the advance view
    if( advance_view !== undefined ){
      advance_view_size = advance_view.clientHeight;
    }

    const old_height = this.state.render_grid_view_body_height; // Old height
    const other_components_size_offset = 76;

    let grid_view_tabs_size = 0;

    // Getting the size of the grid tabs on mobile
    if( grid_view_tabs !== undefined && window.innerWidth < 768 ){
      grid_view_tabs_size = grid_view_tabs.clientHeight;
    }

    // Check this component is mounted/ exist
    if( grid_view_body !== null && grid_view_body !== undefined ){
      const new_height = ( grid_view_body.clientHeight - other_components_size_offset ) - advance_view_size - grid_view_tabs_size;

      try{
        // Update on window size change
        if( new_height !== old_height && this._ismounted === true ){
          this.setState( {
            render_grid_view_body_height: new_height
          } );
        }

      // NotFoundError can happen, so it's fine to just silence it
      }catch( error ){
        if( error.name === 'NotFoundError' ){
          // Do nothing, this error can happen

        // Unknown error will be thrown
        } else {
          throw( error );
        }
      }
    }
  }

  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const bugsnag = this.props.bugsnag;
    const layout = this.state.layout;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    
    let section = {title: 'Page'};

    // Checks to make sure the layout exist
    if( layout ){
      section = layout.section === undefined ? {title: 'Page'} : layout.section;
    }
    
    const status = e.status === undefined ? 0 : e.status;
    if( status === 410 ) {
      alerts.INFO( section.title, 'Your session has expired.' , 5000 );
      this.doLogOff();
    } else if( status === 400 || status === 401 ) {
      if( e.statusText === undefined || e.statusText === 'Unhandled exception has occured!' ) {
        alerts.CRITICAL( section.title, e ); // Reports to bugsnag on unhandled exception
      } else {
        alerts.WARNING( section.title, e.statusText, false ); 
      }
    } else if( status === 500 ) {
      alerts.INFO( section.title, e.statusText , 5000 );
      this.doLogOff();
    } else {
      if( e.statusText === undefined || e.statusText === 'Unhandled exception has occured!' ) {
        alerts.CRITICAL( section.title, e ); // Reports to bugsnag on unhandled exception
      } else {
        alerts.CRITICAL( section.title, e.statusText, false ); // Does not report
      }
    }
  }

  // Forces row refetch from parent, passed up on component mounting
  onParentForceRowReload( filters ){
    if( this.props.onTriggerRowFetch !== undefined ){
      this.props.onTriggerRowFetch( filters, this.buildListRows );
    }
  }

  // Builds linked item triggers
  buildTriggers( ){

    let fields = this.state.layout.section.fields;
    let triggers = [];

    if( fields !== undefined ){
      for( let x = 0; x < fields.length; x++ ){
        if( fields[x].parentcolumn !== undefined ){
          if( fields[x].passin !== undefined ){
            triggers.push( {parent: fields[x].parentcolumn, child: fields[x].column, passin:fields[x].passin} );
          } else {
            triggers.push( {parent: fields[x].parentcolumn, child: fields[x].column} );
          }

        }
      }
    }

    if( this._ismounted === true ){
      this.setState( {linkedtriggers: triggers} );
    }
  }

  // Build the store for dropdown and multiselect used in edit screen
  buildOptionStore( ) {
    const layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const section = layout.section;
    const fields = section.fields;
    if( fields !== undefined ) {
      if( fields.length > 0 ) {
        for( var index = 0; index < fields.length; index++ ) {
          const field = fields[ index ];
          if( field.type === 'dropdown' || field.type === 'multiselect' ) {
            let fieldkeys = Object.keys( field ).join( ' ' ).toLowerCase();
            if( fieldkeys.indexOf( 'routes' ) >= 0 ) {
              this.getOptionStore( field ).then( ( newstore ) => {
                if( this._ismounted === true ){
                  this.setState( {
                    optionstore: newstore
                  } );
                }
              } ).catch( ( error ) => {
                this.onHandleException( error );
              } );
            }
          }
        }
      }
    }
  }

  // Builds options from a section (dynamic layout) passed to it
  buildOptionStoreByValue( given_section ){
    const section = given_section;
    const fields = section.fields;
    if( fields !== undefined ) {
      if( fields.length > 0 ) {
        for( var index = 0; index < fields.length; index++ ) {
          const field = fields[ index ];
          if( field.type === 'dropdown' || field.type === 'multiselect' ) {
            let fieldkeys = Object.keys( field ).join( ' ' ).toLowerCase();
            if( fieldkeys.indexOf( 'routes' ) >= 0 ) {
              this.getOptionStore( field ).then( ( newstore ) => {
                if( this._ismounted === true ){
                  this.setState( {
                    optionstore: newstore
                  } );
                }
              } ).catch( ( error ) => {
                this.onHandleException( error );
              } );
            }
          }
        }
      }
    }
  }

  //Build the store for dropdown and multiselect used in filter section
  buildFilterStore() {
    const layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const filters = layout.filters;

    if( filters !== undefined ) {
      if( filters.length > 0 ) {
        for( var filterindex = 0; filterindex < filters.length; filterindex++ ) {
          const filter = filters[ filterindex ];
          if( filter.type === 'dropdown' || filter.type === 'multiselect' ) {
            this.getFilterStore( filter ).then( ( newstore ) => {
              if( this._ismounted === true ){
                this.setState( {
                  filterstore: newstore
                } );
              }
            } ).catch( ( error ) => {
              this.onHandleException( error );
            } );
          }
        }
      }
    }
  }

  //Build the list of rows for the grid using
  buildListRows( filters ) {
    const searchfilters = filters;
    const layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const section = layout.section;
    const endpoint = section.endpoint;

    this.getListRows( endpoint, searchfilters ).then( ( payload ) => {
      // Filters passed up to allow parents of ListContainer to pass back the filters on a re-render
      this.onParentForceRowReload( searchfilters );

      let allrows = [];

      if( payload.result && payload.result.length !== 0 ){
        allrows = payload.result;
      }

      // Allows for rows to be passed back to parent of ListContainer before being set in the state
      if( this.props.onLoadData !== undefined ){
        allrows = this.props.onLoadData( allrows );
      }

      const pagerows = this.getPageRows( allrows );
      let pagetotal = payload.result !== undefined ? allrows.length : 0;

      if( this._ismounted === true ){

        let pageStart = 1;
        let pageEnd = 50;
        let pageSize = 50;
        if( allrows !== undefined ) {
          if( allrows.length < 50 && allrows.length >= 25 ) {
            pageEnd = 25;
            pageSize = 25
          } else if( allrows.length < 25 ) {
            pageEnd = allrows.length;
            pageSize = 25;
          }
        }

        this.setState( {
          searchfilters: searchfilters,
          search: '',
          pagetotal: pagetotal,
          allrows: allrows,
          filteredrows: pagerows,
          rows: pagerows,
          pagesize: pageSize,
          pagestart: pageStart,
          pageend: pageEnd,
          loading: false,
        } );
      }

    } ).catch( ( error ) => {
      this.onHandleException( error );
    } );
  }

  // Get the options for detail view dropdowns and to store (Promise)
  getOptionStore( field ) {
    let optionstore = this.state.optionstore;
    const routes = field.routes;
    const route = routes.route;
    const key = routes.routekey;
    const id = routes.id;
    const text = routes.text;
    const api = new EtelAPI( route );
    return new Promise( ( resolve, reject ) => {
      api.get( {} ).then( ( result ) => {
        let dropdownitems = [];
        if( result !== undefined ){
          if( result.length > 0 ){
            for( var index = 0;index < result.length; index++ ){
              let dropdownitem = {};
              if( field.type === 'dropdown' ) {
                dropdownitem[ 'id' ] = result[ index ][ id ];
                dropdownitem[ 'text' ] = result[ index ][ text ];
              }
              if( field.type === 'multiselect' ){
                dropdownitem[ 'value' ] = result[ index ][ id ];
                dropdownitem[ 'label' ] = result[ index ][ text ];
              }
              dropdownitems.push( dropdownitem );
            }
            optionstore[ key ] = dropdownitems;
          }
        }
        resolve( optionstore );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  // Get all options for filter dropdowns and add to store in state (Promise)
  getFilterStore( filter ) {
    let filterstore = this.state.filterstore;
    return new Promise( function( resolve, reject ) {
      const routes = filter.routes;
      const route = routes.route;
      const key = routes.routekey;
      const id = routes.id;
      const text = routes.text;
      const api = new EtelAPI( route );
      api.get( {} ).then( ( result ) => {
        let dropdownitems = [];
        if( result !== undefined ){
          if( result.length > 0 ){
            for( var index = 0;index < result.length; index++ ){
              let dropdownitem = {};
              if( filter.type === 'dropdown' ) {
                dropdownitem[ 'id' ] = result[ index ][ id ];
                dropdownitem[ 'text' ] = result[ index ][ text ];
              }
              if( filter.type === 'multiselect' ) {
                dropdownitem[ 'value' ] = result[ index ][ id ];
                dropdownitem[ 'label' ] = result[ index ][ text ];
              }
              dropdownitems.push( dropdownitem );
            }
            if( filter.type === 'dropdown' || filter.type === 'multiselect' ) {
              const includeall = filter.includeall !== undefined ? filter.includeall : false;
              if( includeall === true ) {
                dropdownitems.unshift( filter.alloption );
              }
            }
            filterstore[ key ] = dropdownitems;
          }
        }
        resolve( filterstore );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  // Get the list of rows for the grid to display (Promise)
  getListRows( endpoint, filters ) {
    return new Promise( ( resolve, reject ) => {
      let api = new EtelAPI( endpoint );
      let parameters = [];

      /* Build the parameter list */
      let keys = Object.keys( filters );
      
      if( keys !== undefined ) {
        if( keys.length > 0 ) {
          for( var index = 0;index < keys.length; index++ ) {
            const key = keys[ index ];
            let parameter = {};
            if( ( filters[ key ] !== undefined ) && ( filters[ key ] !== null ) && ( filters[ key] !== '' ) ) {
              parameter[ key ] = filters[ key ];
              parameters.push( parameter );
            }
          }
        }
      }

      api.get( parameters ).then( ( result ) => {
        const page_id = this.state.id;
        
        let payload = {
          result: result
        };

        // Special rendering change for Transport Cost
        if( page_id === 'TransportCostList' ){
          // In this case we have an array of value for CALL_LEG, but we only care about the full name to be displayed so we need to
          // add a display prop
          let new_payload = {
            result: []
          };

          for( let payload_array_i = 0; payload_array_i < result.length; payload_array_i++ ){
            let new_row = result[payload_array_i];
            new_row.CALL_LEG_DISPLAY = new_row.CALL_LEG[1];
            new_payload.result.push(new_row);
          }

          payload = new_payload;
        }

        resolve( payload );
      } ).catch( ( error ) => {
        reject( error );
      } );
    } );
  }

  // Get the current rows that will be displayed in grid
  getPageRows( allrows ) {
    let rows = [];
    const pagesize = this.state.pagesize;
    const pageindex = this.state.pageindex;
    let start = ( pageindex * pagesize );
    let end = start + pagesize;

    if( allrows !== undefined ) {
      if( allrows.length > 0 ) {

        if( pagesize > allrows.length ) {
          start = 0;
          end = allrows.length;
        }

        for( var index = start; index < end; index++ ) {
          rows.push( allrows[ index ] );

        }
      }
    }

    return rows;
  }

  // Fires when page size changes
  onPageSizeChanged( pagesize ) {
    const allrows = this.state.allrows;
    let rows = [];
    for( var index = 0; index < pagesize; index++ ) {
      const allrow = allrows[ index ];
      rows.push( allrow );
    }

    if( this._ismounted === true ){
      this.setState( {
        pagestart: 1,
        pageend: pagesize,
        pageindex: 0,
        pagesize: pagesize,
        rows: rows
      } );
    }
  }

  // Searches all available rows and returns what is requested from the query
  onSearchChanged( e ) {
    let { dispatch } = this.props;
    let layout = this.state.layout;
    let section = layout.section;
    let headers = section.headers;
    const allrows = clone( this.state.allrows );
    const searchstring = e.target.value.toLowerCase();
    const isfiltered = e.target.value.length === 0 ? false : true;
    let myrows = allrows;


    dispatch( event( section.title, section.endpoint , 'FUZZY SEARCH: ' + e.target.value ) );

    if( searchstring.length > 0 ) {
      // New row filters
      let newfilteredrows = [];
      let newfilteredcount = 0;

      for( var rowindex = 0; rowindex < myrows.length; rowindex++ ) {
        const myrow = myrows[ rowindex ];

        if( myrow !== undefined ) {
          const keys = headers === undefined ? Object.keys( myrow ) : headers.map( header => header.column );

          for( var keyindex = 0; keyindex < keys.length; keyindex++ ) {
            const key = keys[ keyindex ];
            let myvalue = myrow[ key ];

            if( ( myvalue !== undefined ) && ( myvalue !== null ) ) {
              myvalue = myvalue.toString().toLowerCase().replace( /-/g,'' );
              if( myvalue.indexOf( searchstring ) >= 0 ) {
                newfilteredcount++;
                newfilteredrows.push ( myrow );
                break;
              } //if( myvalue.indexOf( searchstring ) >= 0 )
            } //if( ( myvalue !== undefined ) &&  ( myvalue !== null ) )
          } //if( myrow !== undefined )
        } //for( var rowindex = 0; rowindex < myrows.length; rowindex++ )
      } // if( searchstring.length > 0 )
      //newRows = newfilteredrows.splice( this.state.pageindex * this.state.pagesize + this.state.pageindex, this.state.pagesize * ( this.state.pageindex + 1 ) );
      if( this._ismounted === true ){
        this.setState( {
          pageindex: 0,
          filtered: isfiltered,
          filteredrows: newfilteredrows,
          rows: newfilteredrows,
          filteredcount: newfilteredcount,
          search: e.target.value
        } );
      }

    } else {
      let newRows = allrows.splice( this.state.pageindex * this.state.pagesize + this.state.pageindex, this.state.pagesize * ( this.state.pageindex + 1 ) );

      if( this._ismounted === true ){
        this.setState( {
          pageindex: 0,
          filtered: false,
          filteredrows: [],
          filteredcount: 0,
          rows: newRows,
          search: e.target.value
        } );
      }
    }
  }

  // Show the current tab selected
  onSelectTab( eventKey, e ){
    const { dispatch } = this.props;
    const layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const section = layout.section;
    const endpoint = section.endpoint;
    const selectedtab = this.state.selectedtab;
    const tabs = layout.tabs;
    const history = this.props.history;
    let tabKey = 0;

    for( var tabindex = 0; tabindex < tabs.length; tabindex++ ) {
      const tab = tabs[ tabindex ];
      tabKey = tab.eventKey;
      if( parseInt( tabKey, 10 ) === parseInt( eventKey, 10 ) ){
        if( eventKey !== selectedtab ){
          dispatch( setRedirectUri( tab.route ) );
          dispatch( event( section.title, endpoint, 'TAB CHANGE: ' + tab.route ) );
          history.push( tab.route );
          break;
        }
      }
    }
  }

  // Change the page size
  onPageChanged( page, e ) {
    const index = page.index;
    const start = page.start;
    const end = page.end;
    const isfiltered = this.state.filtered;
    let rows = [];


    let allrows = this.state.allrows;
    if( isfiltered === true ){
      allrows = this.state.filteredrows;

    }
    const startindex = start-1;
    const endindex = end-1;

    for( var rindex = startindex; rindex <= endindex; rindex++ ){
      rows.push( allrows[rindex] );
    }

    if( this._ismounted === true ){
      this.setState( {
        rows: rows,
        pageindex: index,
        pagestart: start,
        pageend: end,
        loading: false,
        uploadfiles: {0:[], 1:[], 2:[]},
        allfiles: []
      } );
    }
  }

  // Show the edit screen with a new item
  onNewItem( e ){
    let dialogs = ['WholesaleCompanyList','JobsList','Lp247GrossMedSalesList']
    if ( dialogs.includes(this.state.id) === true  ) {
      if ( this.props.onNewItem !== undefined ) {
        let args = {
          reload: this.onLoadRowsFromDialog
        }
        this.props.onNewItem( args );
      }
      return;
    }

    let layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const ismultilayout = this.state.multilayout === undefined ? false : this.state.multilayout;

    // Multilayout
    if( ismultilayout === true ){
      if( this.state.layoutselection !== undefined ){
        layout = this.state.layoutselection;
      } else {
        const optkey = this.state.layoutkey;
        if( optkey !== undefined ){
          const options = this.state.layoutoptions;
          for( let i = 0; i < options.length; i++ ){
            if( options[i]['key'] === optkey ){
              layout = options[i]['layout'];
              break;
            }
          }
        }
      }
    }

    const section = layout.section;
    let newitem = section.newitem;
    let fields = section.fields;
    const editmode = section.editmode;

    // Selects custom modal rendering
    const modal_type = layout.newbutton.is_custom;

    let currentitem = {};
    var keys = Object.keys( newitem );

    for( var index = 0; index < keys.length; index++ ){
      let key = keys[index];
      let value; // *_ID default
      let routekey;
      let field_obj;

      // Maps default properties to objects
      for( var fieldindex = 0; fieldindex < fields.length; fieldindex++ ) {
        const field = fields[ fieldindex ];
        if( field.column === key ) {
          field_obj = field;
        }
      }

      // Sets the default selection for the dropdown to be the first index of it's options
      if( typeof( field_obj ) !== 'undefined' ){
        if( field_obj.type === 'dropdown' ) {
          // The first index
          routekey = field_obj['routes'].routekey;

          // Promise has not returned yet
          if( this.state.optionstore[routekey] === undefined ) {
            value = 0;
          } else {

            value = this.state.optionstore[routekey][0].id;
          }

        } else if( field_obj.type === 'linkeddropdown' ){
          let route = field_obj.routes.route;
          const value = field_obj.routes.value;
          const text = field_obj.routes.text;
          let optionkeys = field_obj.optionkeys;

          // Default paths for new item
          for( let p = 0; p < optionkeys.length; p++ ){
            const k = Object.keys( optionkeys[p] );
            const v = optionkeys[p][k];
            let r = v;

            // If the value is a string, then we look up the value in
            // the optionstore
            if( typeof( v ) === 'string' ){
              r = this.state.optionstore[v][0].id;
              if( r === undefined ){
                r = v;
              }
            }
            route = route.replace( ':' + k, r );
          }

          // Setting the value of pgm_voicefiles_linkedoptions
          let api = new EtelAPI( route );
          // Gets a list of options available
          api.getlist( route ).then( ( result ) => {
            this.updatePGMVoiceOptions( result, value, text );
          } );

        } else {
          value = newitem[key];
        }
      }

      // Checks to see that all items are defined
      if( value === undefined ){
        value = newitem[key];
        // Default value if not referenced in the layout
        if( value === undefined ){
          value = 0;
        }
      }
      // Will default to 0 on values that register as undefined
      currentitem[key] = value;
    }

    if( modal_type === 'None' || modal_type === undefined ) {
      if( editmode === 'dialog' ) {
        if( this._ismounted === true ){
          this.setState( {
            dialogMode: 'NEW',
            currentitem: currentitem,
            showdetailview: false,
            insertcomplete: false,
            uploadcomplete: false,
            fileuploadcomplete: false,
            showProgramsDialog: false,
            uploadfiles: {0:[], 1:[], 2:[]},
            allfiles: [],
            pgm_route_type: 4
          } );
        }
      } else {
        if( this._ismounted === true ){
          this.setState( {
            detailviewmode: 'NEW',
            currentitem: currentitem,
            showdetailview: true,
            insertcomplete: false,
            uploadcomplete: false,
            fileuploadcomplete: false,
            showProgramsDialog: false,
            uploadfiles: {0:[], 1:[], 2:[]},
            allfiles: [],
            pgm_route_type: 4
          } );
        }
      }
    } else {
      // Shows the programs
      if( modal_type === 'programs' && this._ismounted === true ){
        this.setState( {
          detailviewmode: 'NEW',
          currentitem: currentitem,
          showdetailview: false,
          insertcomplete: false,
          uploadcomplete: false,
          fileuploadcomplete: false,
          showProgramsDialog: true, // Show the custom dialog for this button
          uploadfiles: {0:[], 1:[], 2:[]},
          allfiles: [],
          pgm_route_type: 4
        } );
      }
    }
  }

  // Show the edit screen with a current item selected
  onEditItem( row, e ) {
    let layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    if( this.state.multilayout === true ){
      if( this.state.layoutselection !== undefined ){
        layout = this.state.layoutselection;
      } else {
        if( row['TEMPLATE_MAIN_ID'] !== undefined && this.state.layoutoptions !== undefined){
          const template_main_id = parseInt(row['TEMPLATE_MAIN_ID'], 10);
          this.state.layoutoptions.forEach(array_layout => {
            if(array_layout['key'] === template_main_id){
              layout = array_layout.layout;
            }
          });
        }
        else {
          layout = this.state.layoutoptions[0]['layout'];
        }
      }
    }

    const section = layout.section;
    const fields = section.fields;
    const canEdit = section.canedit === undefined ? true : section.canedit;
    const endpoint = section.endpoint;
    const rowkey = section.rowkey;

    if( this.state.detailviewmode === 'NEW' ) {
      return;
    }

    if( this.state.multilayout === true ){
      // We need a field or field label in the actual row to define what layout to load
      // -- add row fields to reverse the layout options here
      if( row['Payout_Type'] !== undefined || row['TEMPLATE_MAIN_ID'] !== undefined ){
        if( endpoint !== undefined ){
          let api = new EtelAPI( endpoint );
          let item = {};
          item[layout.section['rowkey']] = row[layout.section['rowkey']];
          api.get( [item] ).then( ( result ) => {
            const TEMPLATE_MAIN_ID = parseInt( result[0]['TEMPLATE_MAIN_ID'], 10 );
            let layoutselection;
            const options = this.state.layoutoptions;
            for( let i=0; i < options.length; i++ ){
              if( options[i]['key'] === TEMPLATE_MAIN_ID ){
                layoutselection = options[i]['layout'];
                break;
              }
            }

            let layout_newitem = layoutselection['section']['newitem'];
            let newitem = clone( row );
            const newfieldkeys = Object.keys( layout_newitem );
            const item = result[0];
            let new_currentrow = {};

            for( let i = 0; i < newfieldkeys.length; i++ ){
              let key = newfieldkeys[i];
              new_currentrow[key] = item[key] === undefined ? newitem[key] : item[key];
            }

            if( this._ismounted === true ){
              // Renders on change
              this.setState( {
                detailviewmode: 'EDIT',
                currentitem: new_currentrow,
                layoutkey: TEMPLATE_MAIN_ID,
                showdetailview: true,
                insertcomplete: false,
                updatecomplete: false,
                fileuploadcomplete: false,
                showProgramsDialog: false,
                onoffnet_fileheaders: [],
                layoutselection: layoutselection
              } );
            }
          } );
        }
      }
    } else {
      let parameters = [];
      let item = {};
      let currentrow = row;

      // Custom modal new button
      const modal_type = layout.newbutton.is_custom;

      item[rowkey] = row[rowkey];

      if( canEdit === false ){
        return;
      }

      parameters.push( item );

      let api = new EtelAPI( endpoint );

      api.get( parameters ).then( ( result ) => {

        if( result.length > 0 ){

          currentrow = result[0];

          // Destroys the previous block if a new row is selected (only if)
          if( this.state['currentitem'][rowkey] !== undefined && this.state['currentitem'][rowkey] !== currentrow[rowkey] ){
            if( this._ismounted === true ){
              this.setState( {uploadfiles: {0:[], 1:[], 2:[]}, allfiles: []} );
            }
          }

          for( var fieldindex = 0; fieldindex < fields.length; fieldindex++ ) {
            const field = fields[ fieldindex ];
            if( field.type === 'multiselect' ) {
              let optionrows = currentrow[ field.column ];
              if( ( optionrows !== undefined ) && ( JSON.stringify( optionrows ) !== '{}' ) ){
                for( var optionindex = 0; optionindex < optionrows.legnth; optionindex++ ) {
                  optionrows[optionindex]['STATUS'] = 'CURRENT';
                }
              }
            } else if( field.type === 'linkeddropdown' ){
              let route = field.routes.route;
              const value = field.routes.value;
              const text = field.routes.text;
              let optionkeys = field.optionkeys;
              const current_item = currentrow;

              // Default paths for new item
              for( let p = 0; p < optionkeys.length; p++ ){
                const k = Object.keys( optionkeys[p] );
                let r = current_item[k];
                if( r === '' || r === undefined || r === null ){
                  r = 0;
                }

                route = route.replace( ':' + k, r );
              }

              // Setting the value of pgm_voicefiles_linkedoptions
              let api = new EtelAPI( route );
              // Gets a list of options available
              api.getlist( route ).then( ( result ) => {
                this.updatePGMVoiceOptions( result, value, text );
              } );
            }
          }

          // Creating a copy of the currentrow so waiting changes don't get applied with
          // a new search
          const newitemx = Object.assign( {}, currentrow );

          // Shows the programs
          if( modal_type === 'programs' ){

            // Getting the pgm_route_type (ROUTING_TYPE_ID)
            const route_type = currentrow['ROUTING_TYPE_ID'];

            if( this._ismounted === true ){
              this.setState( {
                detailviewmode: 'EDIT',
                currentitem: newitemx,
                showdetailview: false,
                insertcomplete: false,
                updatecomplete: false,
                fileuploadcomplete: false,
                showProgramsDialog: true, // Show the custom dialog for this button
                ONOFFNET_PGM_MAIN_ID: currentrow.PGM_MAIN_ID,
                pgm_route_type: route_type,
              } );
            }
            // Default none custom modal renders
          } else {

            if( this._ismounted === true ){
              this.setState( {
                detailviewmode: 'EDIT',
                currentitem: newitemx,
                showdetailview: true,
                insertcomplete: false,
                updatecomplete: false,
                fileuploadcomplete: false,
                showProgramsDialog: false, // Show the custom dialog for this button
                onoffnet_fileheaders: [],
              } );
            }
          }
        }
      } ).catch( ( error ) => {

        this.onHandleException( error );

        if( this._ismounted === true ){
          this.setState( {
            detailviewmode: '',
            showdetailview: false,
          } );
        }
      } );
    }
  }

  // Updates the pgm_voicefiles_linkedoptions in the global state
  updatePGMVoiceOptions( new_values, valuename, textname ){

    let values = [];
    let v;

    // Changing the structure to fit what a linkedDropdown expects (same as a normal dropdown)
    for( v = 0; v < new_values.length; v++ ){
      values.push( {value: new_values[v][valuename], text: new_values[v][textname]} );
    }

    if( this._ismounted === true ){
      this.setState( {
        pgm_voicefiles_linkedoptions: values
      } );
    }
  }

  // Create a new item
  onNewSubItem( e ) {
    const layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const section = layout.section;
    const rowkey = section.rowkey;
    const currentitem = this.state.currentitem;
    let gridnewitem = this.state.gridnewitem;
    let gridrows = this.state.gridrows;
    let newrow = {};

    const gridnewrow = gridnewitem.newrow;
    let keys = Object.keys( gridnewrow );
    for( var index = 0; index < keys.length; index++ ){
      let key = keys[ index ];
      newrow[ key ] = gridnewrow[ key ];
      if( key === rowkey ){
        newrow[ key ] = currentitem[ key ];
      }
    }
    newrow.mode ='NEW';
    newrow.changed = false;

    gridrows.push( newrow );

    if( this._ismounted === true ){
      this.setState( { gridrows: gridrows } );
    }
  }

  // Delete the current item being edited
  onDeleteSubItem( args, e ){
    const rowindex = args.rowindex;
    const gridrows = this.state.gridrows;
    let newgridrows = [];
    for( var index = 0; index < gridrows.length; index++ ){
      if( rowindex !== index ){
        newgridrows.push( gridrows[index] );
      } else {
        let gridrow = gridrows[ index ];
        gridrow.mode = 'DELETE';
        newgridrows.push( gridrow );
      }
    }

    if( this._ismounted === true ){
      this.setState( { gridrows: newgridrows } );
    }
  }

  // Cancel current item that being edited
  onCancelItem( e ) {

    // The original (single layout)
    const reset_layout = clone( this.state.layout );

    // Standard clearing of variables, these are the default
    // needed to reset the state on a cancel
    if( this.state.layout === reset_layout && this._ismounted === true ) {
      this.setState( {
        detailviewmode: '',
        currentitem: {},
        showdetailview: false,
        allfiles: [],
        description: '',
        defdnis: '',
        uploadfiles: {0:[], 1:[], 2:[]},
        trueuploadfiles: {0:[], 1:[], 2:[]},
      } );

    // Resets the layout back to the original (first) layout
    } else {
      if( this._ismounted === true ){
        this.setState( {
          layout: reset_layout,
          detailviewmode: '',
          currentitem: {},
          showdetailview: false,
          allfiles: [],
          description: '',
          defdnis: '',
          uploadfiles: {0:[], 1:[], 2:[]},
          trueuploadfiles: {0:[], 1:[], 2:[]},
        } );
      }
    }
  }

  // Save current item that being edited
  onSaveItem( e ){

    let layout = this.state.layout === undefined ? this.props.layout : this.state.layout;

    if( this.state.multilayout === true ){
      if( this.state.layoutselection !== undefined ){
        layout = this.state.layoutselection;
      } else {
        layout = this.state.layoutoptions[0]['layout'];
      }
    }

    const section = layout.section;
    let filecount = 0;
    let fileuploadstatus = this.state.fileuploadstatus;
    const currentitem = this.state.currentitem;

    // Get a total count before processing the files
    fileuploadstatus['TOTAL_COUNT'] = 0;
    for( var i = 0; i < 3; i++ ){
      for( var j = 0; j < this.state['uploadfiles'][i].length; j++ ){
        fileuploadstatus['TOTAL_COUNT'] = filecount + 1;
        filecount += 1;
      }
    }

    //We only want to show the modal when the user uploads a file
    //Check if files.length > 0
    if ( section.save !== undefined && currentitem !== undefined ){
      if ( section.save.toLowerCase() === 'leadgen' ){
        if ( fileuploadstatus['TOTAL_COUNT'] > 0 ){

          if( this._ismounted === true ){
            // Enable dialog state to true
            this.setState( {
              showsavedialog:true,
              dialogtitle:'Leadgen Progress For ' + currentitem.GROUP_NAME,
              fileuploadstatus:fileuploadstatus
            } );
          }
        }
      }
    }

    if( this.state.detailviewmode === 'NEW' ) {
      this.onInsertItem( currentitem, section.endpoint );
    } else {
      this.onUpdateItem( currentitem, section.endpoint );
    }

    // Sending files, GROUP_NAME and DEFDNIS must be included before these can be saved
    if( currentitem['GROUP_NAME'] !== '' && currentitem['DEFDNIS'] !== '' ) {
      for( var upload_type_index = 0; upload_type_index < 3; upload_type_index++ ) {
        for( var files = 0; files < this.state['uploadfiles'][upload_type_index].length; files++ ) {
          this.readFile( this.state['uploadfiles'][upload_type_index][files] );
        }
      }
    }
  }

  onSaveAndContinue( e ) {
    if( this._ismounted === true ){
      this.setState( {
        allowsaveandcontinue: e.target.checked
      } );
    }
  }

  // Saves from the Program modal - Saves based on current tab (not all tabs changed), does not prompt user before saving
  onSaveItemFromPrograms( e ){

    /* Note::
    / To make e (events) valid with this function, send back events
    / with this format {
      'target':{
        'name': ```name of the case to call```,
        'payload': ```contents of payload```
      }
    } */

    const name = e.target.name;
    const payload = e.target.payload;

    // Saves for ProgramInputs
    if( name === 'ProgramInputs' ){
      // Checking if the payload is equal to === 0 which is
      // the same as an onCancel

      if( payload !== 0 ){
        const value = parseInt( payload['PGM_MAIN_ID'], 10 );

        if( ( parseInt( value, 0 ) === 0 ) || ( value === '' ) || ( value === undefined ) || ( value === null ) ){
          this.onInsertItem( payload, 'programs' );
        } else {
          this.onUpdateItem( payload, 'programs' );
        }
      }

    // Payload from GroupSettings
    } else if( name === 'GroupSettings' ){

      if( payload !== 0 ){
        const value = parseInt( payload['PGM_GROUP_ID'], 10 );
        if( ( parseInt( value, 0 ) === 0 ) || ( value === '' ) || ( value === undefined ) || ( value === null ) ){
          this.onInsertItem( payload, 'programs/pgmgroup' );
        } else {
          this.onUpdateItem( payload, 'programs/pgmgroup' );
        }
      }
    }

    // Reset to an inactive modal
    this.onCloseItemFromPrograms( e );
  }

  // Closes the modal for Programs
  onCloseItemFromPrograms( e ){
    if( this._ismounted === true ){
      // Reset the current selected tab to be 0 (programs)
      this.setState( {
        showProgramsDialog: false,
        currentProgramTab: 0,
        detailviewmode: ''
      }, () => {
        // Notify parent to also change its state
        this.props.onProgramsDialogClose( e );
      } );
    }
  }

  // Trigger for tab changed
  onChangedProgramsTab( key, content ) {
    // Mapping for programs
    /*
     - 0 --> Settings
     - 1 --> Schedule
     - 2 --> Onnet Files (or) Offnet Files
     - 3 --> History
     - 4 --> Group Settings
    */

    if( this._ismounted === true ){
      this.setState( {
        currentProgramTab: key
      } );
    }
  }

  // Send the insert request to the back-end, allows for
  // path (endpoint) to be passed in
  onInsertItem( currentitem, path ){
    let endpoint = path;
    const { bugsnag, dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const section = layout.section;
    let allrows = clone( this.state.allrows );
    let filteredrows = clone( this.state.filteredrows );
    const filtered = this.state.filtered;

    // Allows for endpoint to be dynamically declared, but
    // will default to the layout's definition if not
    // declared. Used primarely by modal that have multiple
    // endpoints inside each tab layout.
    if( endpoint === undefined ){
      endpoint = section.endpoint;
    }

    let api = new EtelAPI( endpoint );
    let successAlert = 'Successfully created new ' + section.title;

    if( this.onValidate( currentitem ) === false ) {
      return 1; // Block can not be empty
    } else {

      let newitem;

      // Group Settings do not contain all the items in a new Program, this is a special case since it does not
      // contain a layout and needs to bypass getParentPayload
      if( currentitem['M_PDNIS'] === undefined && currentitem['S_PDNIS'] === undefined ){
        newitem = this.getParentPayload( currentitem );
      } else {
        newitem = currentitem;
      }


      api.insert( newitem ).then( ( result ) => {
        const status = result.status;
        let row = result.data[0];
        
        // Happens in V2 Program INSERT, the INSERT is fine but the reply
        // does not come back with data (the new row)
        if( status === 200 && result.data.length === 0 && path === 'programs'){
          dispatch( event( section.title, endpoint, 'INSERT' ) );
          alerts.SUCCESS( section.title, successAlert, 5000 );
          api.get( {} ).then( ( result ) => {
            if( this._ismounted === true ){
              this.setState( {
                allrows: result,
                filteredrows: filteredrows,
                showdetailview: false,
                insertcomplete: true
              } );
            }
          } ).catch( ( error ) => {

            this.onHandleException( error );

          } );
        } else {

          dispatch( event( section.title, endpoint, 'INSERT' ) );
          this.saveMultiSelectRows( row ).then( ( result_2 ) => {
  
            row['PGM_MAIN_ID'] = parseInt( result_2['PGM_SCHEDULE_NAME_ID'], 10 );
            // Unneccessary; added duplicates to the list grid
            // if( result_2['PGM_SCHEDULE_NAME_ID'] === undefined ){
            //   allrows.push( row );
            // }
  
            if( filtered === true ) {
              const search = this.state.search.toString().toLowerCase();
              const keys = Object.keys( row );
              for( var index = 0; index < keys.length; index++ ){
                const key = keys[index];
                const value = row[key].toString().toLowerCase();
                if( value.indexOf( search ) >= 0 ) {
                  if( filteredrows !== undefined ) {
                    filteredrows.unshift( row );
                    break;
                  }
                }
              }
            }
  
            // Add to beginning to all rows
            if( allrows !== undefined ) {
              allrows.unshift( row );
            }
  
            if( path === 'programs' ) {
  
              api.get( {'PDNIS': newitem['PDNIS']} ).then( ( result ) => {
                if( this._ismounted === true ){
                  this.setState( {
                    allrows: result,
                    filteredrows: filteredrows,
                    showdetailview: false,
                    insertcomplete: true,
                  } );
                }
              } ).catch( ( error ) => {
  
                this.onHandleException( error );
  
              } );
  
            } else {
  
              const allowsaveandcontinue = this.state.allowsaveandcontinue;
  
              if( this._ismounted === true ){
                this.setState( {
                  detailviewmode: '',
                  allrows: allrows,
                  filteredrows: filteredrows,
                  currentitem: row,
                  showdetailview: allowsaveandcontinue,
                  insertcomplete: true,
                } );
              }
            }

            alerts.SUCCESS( section.title, successAlert, 5000 );
  
          } ).catch( ( error ) => {
  
            this.onHandleException( error );
  
          } );
        }
      } ).catch( ( error ) => {

        this.onHandleException( error );

      } );
    }
  }

  // Send the update request to the back-end
  onUpdateItem( currentitem, path ) {
    let endpoint = path;
    let layout = this.state.layout === undefined ? this.props.layout : this.state.layout;

    if( this.state.multilayout === true ){
      if( this.state.layoutselection !== undefined ){
        layout = this.state.layoutselection;
      } else {
        layout = this.state.layoutoptions[0]['layout'];
      }
    }

    const section = layout.section;
    const rowkey = section.rowkey;
    const { bugsnag, dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );

    // Allows for the endpoint to be dynamically declared, but
    // will default to the layout's definition if not
    // declared. Used primarely by modal that have multiple
    // endpoints inside each tab layout.
    if( endpoint === undefined ){
      endpoint = section.endpoint;
    }

    let allrows = clone( this.state.allrows );
    let filteredrows = clone( this.state.filteredrows );
    let api = new EtelAPI( endpoint );

    let updateditem = this.getParentPayload( currentitem );
    let successAlert = 'Successfully updated ' + section.title;

    api.update( updateditem ).then( ( result ) => {

      dispatch( event( section.title, endpoint, 'UPDATE' ) );

      const row = result.data[0];

      if( this._ismounted === true ){

        let rowindex = 0;

        //** Update allrows with new value **//
        for( rowindex = 0; rowindex < allrows.length; rowindex++ ) {
          const allrow = allrows[ rowindex ];
          if( allrow[rowkey] === row[rowkey] ) {
            allrows[rowindex] = row;
          }
        }

        //** Update all filtered rows **//
        const filtered = this.state.filtered;
        if( filtered === true ) {
          for( rowindex = 0; rowindex < filteredrows.length; rowindex++ ) {
            const filteredrow = filteredrows[ rowindex ];
            if( filteredrow[rowkey] === row[rowkey] ){
              filteredrows[rowindex] = row;
            }
          }
        }

        const allowsaveandcontinue = this.state.allowsaveandcontinue;

        this.setState( {
          allrows: allrows,
          filteredrows: filteredrows,
          currentitem: row,
          showdetailview: allowsaveandcontinue,
          updatecomplete: true
        }, ( ) => {

          this.saveMultiSelectRows( row ).then( ( results ) => {

            alerts.SUCCESS( section.title, successAlert, 5000 );

            this.onFilterSearch( this.state.searchfilters, {} )

          } ).catch( ( error ) => {

            this.onHandleException( error );

            if( this._ismounted === true ){
              this.setState( {
                showdetailview: false,
                updatecomplete: 'failed'
              } );
            }
          } );

        } );
      }

    } ).catch( ( error ) => {

      this.onHandleException( error );

      if( this._ismounted === true ){
        this.setState( {
          showdetailview: false,
          updatecomplete: 'failed'
        } );
      }

    } );
  }

  //Show the delete dialog
  onDeleteItem( e ){
    if( this._ismounted === true ){
      this.setState( {
        showdeletedialog: true
      } );
    }
  }

  // Confirm the delete
  onConfirmDelete( e ) {
    const { bugsnag, dispatch } = this.props;
    let layout = this.state.layout === undefined ? this.props.layout : this.state.layout;

    if( this.state.multilayout === true ){
      if( this.state.layoutselection !== undefined ){
        layout = this.state.layoutselection;
      } else {
        layout = this.state.layoutoptions[0]['layout'];
      }
    }

    const section = layout.section;
    const endpoint = section.endpoint;
    const rowkey = section.rowkey;
    const currentitem = this.state.currentitem;
    const allrows = clone( this.state.allrows );
    let newallrows = [];
    const pagerows = clone( this.state.rows );
    let newpagerows = [];
    const filteredrows = clone( this.state.filteredrows );
    let newfilteredrows = [];
    let api = new EtelAPI( endpoint );
    const alerts = new Alerts( bugsnag, dispatch );
    const successAlert = 'Successfully deleted from ' + section.title;

    api.delete( currentitem[ rowkey ] ).then( ( result ) => {

      dispatch( event( section.title, endpoint, 'DELETE' ) );

      let row = result.data[0];

      //All rows
      for( var index = 0; index < allrows.length; index++ ) {
        const allrow = allrows[ index ];
        if( allrow[rowkey] !== row[rowkey] ) {
          newallrows.push( allrow );
        }
      }

      for( index = 0; index < pagerows.length; index++ ) {
        const pagerow = pagerows[ index ];
        if( pagerow[rowkey] !== row[rowkey] ) {
          newpagerows.push( pagerow );
        }
      }

      const filtered = this.state.filtered;
      if( filtered === true ){
        for( index = 0; index < filteredrows.length; index++ ) {
          const filteredrow = filteredrows[ index ];
          if( filteredrow[rowkey] !== row[rowkey] ) {
            newfilteredrows.push( filteredrow );
          }
        }
      } else {
        newfilteredrows = filteredrows;
      }

      alerts.SUCCESS( section.title, successAlert, 5000 );

      if( this._ismounted === true ){
        this.setState( {
          detailviewmode: '',
          allrows: newallrows,
          rows: newpagerows,
          filteredrows: newfilteredrows,
          showdeletedialog: false,
          showdetailview: false,
          uploadfiles: {0:[], 1:[], 2:[]},
          allfiles: []
        } );
      }

    } ).catch( ( error ) => {

      this.onHandleException( error );

      if( this._ismounted === true ){
        this.setState( {
          detailviewmode: '',
          showdeletedialog: false,
          showdetailview: false,
          uploadfiles: {0:[], 1:[], 2:[]},
          allfiles: []
        } );
      }
    } );
  }

  //Cancel the delete
  onCancelDelete( e ){
    if( this._ismounted === true ){
      this.setState( {
        detailviewmode: '',
        showdeletedialog: false,
        showdetailview: false,
      } );
    }
  }

  // Update changed field
  onChangeItem( field, e ) {
    let layout = this.state.layout === undefined ? this.props.layout : this.state.layout;

    if( this.state.multilayout === true ){
      if( this.state.layoutselection !== undefined ){
        layout = this.state.layoutselection;
      } else {
        layout = this.state.layoutoptions[0]['layout'];
      }
    }

    const section = layout.section;
    const currentitem = this.state.currentitem;
    const fieldkey = field.column;
    const fieldtype = field.type;
    let route_value;
    let show_value = this.state.pgm_route_to_value_show;
    let index = 0;
    let optionindex = 0;

    /* Available Route Types ::
      -- 4,  CANADIAN
      -- 3,  COUPONS
      -- 1,  DNIS SET
      -- 7,  LEADGEN
      -- 9,  LEADGEN-MA
      -- 6,  MULTI AD
      -- 8,  SECONDARY
      -- 5,  US CELL
      -- 10, UTILITY
    */
    if( fieldkey === 'ROUTING_TYPE_ID' ){
      route_value = e.target.value;
    } else {
      route_value = this.state.pgm_route_type;
    }

    // To show the additional to value input for ROUTE_TO
    if( fieldkey === 'ROUTE_TO' ){
      if( e.target.value === '2' || e.target.value === '3' ){
        show_value = true;
      } else {
        show_value = false;
      }
    }

    if( fieldkey !== undefined ){
      if( fieldtype === 'multiselect' ) {
        const routes = field.routes;
        const value = routes.id;
        let optionrows = currentitem[ fieldkey ] === undefined ? [] : currentitem[ fieldkey ];
        let currentoption;
        for( index = 0; index < e.length; index++ ) {
          const item = e[ index ];
          let itemfound = false;
          for( optionindex = 0; optionindex < optionrows.length; optionindex++ ) {
            const optionrow = optionrows[ optionindex ];
            if( item[ 'value' ] === optionrow[ value ] ) {
              currentoption = optionrow;
              itemfound = true;
            }
          }
          if( itemfound === false ) {
            let newrow = {};
            const newitem = field.newitem;
            let newitemkeys = Object.keys( newitem );
            for( var keyindex = 0; keyindex < newitemkeys.length; keyindex++ ){
              let newitemkey = newitemkeys[ keyindex ];
              const newitemfield = newitem[ newitemkey ];
              if( newitemfield.searchtype === 'parent' ){
                newrow[ newitemkey ] = currentitem[ newitemfield.key ];
              }
              if( newitemfield.searchtype === 'child' ){
                newrow[ newitemkey ] = item[ newitemfield.key ];
              }
              if( newitemfield.searchtype === 'none' ){
                newrow[ newitemkey ] = newitemfield.default;
              }
            }
            newrow['STATUS'] = 'NEW';
            if( currentitem[ fieldkey ] === undefined ){
              currentitem[ fieldkey ] = [];
            }
            currentitem[ fieldkey ].push( newrow );
          } else {
            if( currentoption[ field.rowkey ] !== 0 ) {
              currentoption.STATUS = 'CURRENT';
            }
          }
        }

        //** CHECK ITEMS THAT HAVE BEEN DELETED **//
        for( index = 0; index < optionrows.length; index++ ) {
          const optionrow = optionrows[ index ];
          let optionfound = false;
          for( optionindex = 0; optionindex < e.length; optionindex++ ) {
            const item = e[ optionindex ];
            if( optionrow[ value ] === item[ 'value' ] ){
              optionfound = true;
            }
          }
          if( optionfound === false ){
            optionrow['STATUS'] = 'DELETE';
          }
        }

        // Special change for CollectVFilename (pgm voicefiles)
      } else if( fieldtype === 'dropdown' ) {

        if ( field['column'] === 'ENTITY_ID' && section ) {
          if ( section.endpoint === 'entities/numbers' ) {

            let fields = section.fields;
            let route;
            let value;
            let text;
            for( let x = 0; x < fields.length; x++ ){
              if( fields[x]['column'] === 'PRIMARY_CENTER_ID' ){
                route = fields[x].routes['route'];
                value = fields[x].routes['value'];
                text = fields[x].routes['text'];
                break;
              }
            }

            const ENTITY_ID = e.target.value;
            route = route.replace( ':ENTITY_ID',ENTITY_ID );
            let api = new EtelAPI( route );

            // Gets a list of options available
            api.getlist( route ).then( ( result ) => {
              this.updatePGMVoiceOptions( result, value, text );
            } );

            currentitem[ fieldkey ] = e.target.value;
          } else {
            currentitem[ fieldkey ] = e.target.value;
          }
        } else if( field['column'] === 'CollectDNIS' ) {
          let fields = section.fields;
          let route;
          let value;
          let text;
          for( let x = 0; x < fields.length; x++ ){
            if( fields[x]['column'] === 'CollectVFilename' ){
              route = fields[x].routes['route'];
              value = fields[x].routes['value'];
              text = fields[x].routes['text'];
              break;
            }
          }

          // Changes for pgm voice file only
          const voice_main_id = currentitem['Voice_Main_ID'];
          const collect_dnis = e.target.value;
          route = route.replace( ':Voice_Main_ID', voice_main_id );
          route = route.replace( ':CollectDNIS', collect_dnis );

          // Setting the value of pgm_voicefiles_linkedoptions
          let api = new EtelAPI( route );

          // Gets a list of options available
          api.getlist( route ).then( ( result ) => {
            this.updatePGMVoiceOptions( result, value, text );
          } );

          // Sets the value
          currentitem[ fieldkey ] = e.target.value;

        } else {
          currentitem[ fieldkey ] = e.target.value;
        }
      // } else if( fieldtype === 'multiinput' ){
      //   currentitem[ fieldkey ] = e.target.value;
      } else {
        currentitem[ fieldkey ] = e.target.value;
      }
    } else {
      currentitem[ fieldkey ] = e.target.value;
    }

    // Resolving linked triggers
    const linked_triggers = this.state.linkedtriggers;
    let payload = {};

    for( let ix = 0; ix < linked_triggers.length; ix++ ){
      if( linked_triggers[ix].parent === fieldkey ){

        // Passing in extra values
        if( linked_triggers[ix].passin !== undefined ){

          const passin_items = linked_triggers[ix].passin;
          let payload = {};

          for( let pitem_index = 0; pitem_index < passin_items.length; pitem_index++ ){
            const item_name = passin_items[pitem_index];
            payload[ item_name ] = currentitem[ item_name ];
          }

          currentitem[ linked_triggers[ix].child ] = payload;

        } else {
          payload[linked_triggers[ix].parent] = e.target.value;
          currentitem[ linked_triggers[ix].child ] = payload;
        }
      }
    }

    if( this.state.showProgramsDialog === true ){

      if( this._ismounted === true ){
        this.setState( {
          currentitem: currentitem,
          pgm_route_type: route_value,
          pgm_route_to_value_show: show_value,
        } );
      }
    } else {
      if( this._ismounted === true ){
        this.setState( {
          currentitem: currentitem,
        } );
      }
    }
  }

  // Loads rows with search, this is the refresh on ListContainer from a dialog action
  onLoadRowsFromDialog( ){
    const layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const section = layout.section;
    const endpoint = section.endpoint;
    const search = this.state.search;

    this.getListRows( endpoint, {} ).then( ( payload ) => {

      let pagetotal = payload.result !== undefined ? payload.result.length : 0;

      // Does not remove the search rows
      if( search !== '' ){
        let layout = this.state.layout;
        let section = layout.section;
        let headers = section.headers;
        const allrows = clone( payload.result );
        const searchstring = search.toLowerCase();
        const isfiltered = search.length === 0 ? false : true;
        let myrows = allrows;

        if( searchstring.length > 0 ) {

          // New row filters
          let newfilteredrows = [];
          let newfilteredcount = 0;

          for( var rowindex = 0; rowindex < myrows.length; rowindex++ ) {
            const myrow = myrows[ rowindex ];

            if( myrow !== undefined ) {
              const keys = headers === undefined ? Object.keys( myrow ) : headers.map( header => header.column );

              for( var keyindex = 0; keyindex < keys.length; keyindex++ ) {
                const key = keys[ keyindex ];
                let myvalue = myrow[ key ];

                if( ( myvalue !== undefined ) && ( myvalue !== null ) ) {
                  myvalue = myvalue.toString().toLowerCase().replace( /-/g,'' );
                  if( myvalue.indexOf( searchstring ) >= 0 ) {
                    newfilteredcount++;
                    newfilteredrows.push ( myrow );
                    break;
                  } //if( myvalue.indexOf( searchstring ) >= 0 )
                } //if( ( myvalue !== undefined ) &&  ( myvalue !== null ) )
              } //if( myrow !== undefined )
            } //for( var rowindex = 0; rowindex < myrows.length; rowindex++ )
          } // if( searchstring.length > 0 )
          //newRows = newfilteredrows.splice( this.state.pageindex * this.state.pagesize + this.state.pageindex, this.state.pagesize * ( this.state.pageindex + 1 ) );

          if( this._ismounted === true ){
            this.setState( {
              pageindex: 0,
              filtered: isfiltered,
              filteredrows: newfilteredrows,
              rows: newfilteredrows,
              filteredcount: newfilteredcount,
              search: search,
              allrows: payload.result,
              pagetotal: pagetotal,
              loading: false,
            } );
          }
        }
      } else {

        const pagerows = this.getPageRows( payload.result );

        this.setState( {
          search: '',
          pagetotal: pagetotal,
          allrows: payload.result,
          filteredrows: pagerows,
          rows: pagerows,
          loading: false,
        } );
      }
    } ).catch( ( error ) => {
      this.onHandleException( error );
    } );
  }

  // Set the datasource that was changed by the child
  onDataSourceChanged( datasource ) {
    if( this.state.filtered === false ) {
      this.setState( {
        allrows: datasource
      } );
    } else {
      this.setState( {
        filteredrows: datasource
      } );
    }
  }

  onFormatReadOnlyCellLabel( args ) {
    if( this.props.onFormatReadOnlyCellLabel !== undefined ) {
      this.props.onFormatReadOnlyCellLabel( args );
    }
  }

  onIconClicked( args ) {
    // We have specific pages in ListContainer that acts a certain way and need to keep letting it do so
    // Wholesale Cost (INOUT_Cost)
    if ( args['row']['Payout_Type'] !== undefined ) {
      this.onEditItem( args['row'] );
    } else {
      // Letting ListContainer handle the deletion because it is holding the
      // displayed rows (allrows/filteredrows).
      if ( args.iconKey === 'delete' ) {
        this.setState( {
          currentitem: args.row
        }, () => {
          this.onDeleteItem();
        } );
      } else {
        if( this.props.onIconClicked !== undefined ) {
          args.reload = this.onLoadRowsFromDialog;
          this.props.onIconClicked( args );
        }
      }
    }
  }

  // Inserts from the dialog, refreshes the items, checks to see if a new item
  // is coming from the clicked row panel or a child
  onDialogInsert( args, e ) {
    let currentitem = args.item; // This item will have a "changed" key
    const new_item = this.state.layout.section.newitem; // This is what a new item is expected to have (to update ListContainer)
    const rowkey = this.state.layout.section.rowkey; // Short look up, works for items that don't have the same rowkey

    if( currentitem[rowkey] !== undefined ){
      // Checks if item contains all rows specified in the layouts new item
      let new_count = 0;
      let keys = Object.keys( new_item );

      // Steps through the needed keys, there could be a child addition that holds
      // all of the parents items in which case it will update the ListContainer grid
      for( let i = 0; i < keys.length; i++ ){
        const column = keys[0];
        if( currentitem.hasOwnProperty( column ) === true ){
          new_count += 1;
        }
      }

      // Add the insert to the row only if the item is truely a "parent/panel" addition
      if( new_count === keys.length ){

        // Special for Inbound_SIP in WholeSale Companies
        if( currentitem['Inbound_SIP'] === 'true' ){
          currentitem['Inbound_SIP_Text'] = 'Yes';
        } else if ( currentitem['Inbound_SIP'] === 'false' ){
          currentitem['Inbound_SIP_Text'] = 'No';
        }

        if( this._ismounted === true ){
          this.setState( {
            currentitem: currentitem,
            showdetailview: false,
            dialogMode: 'EDIT',
          }, this.onLoadRowsFromDialog() );
        }

      // Insert from a child tab
      } else {

        if( this._ismounted === true ){
          this.setState( {
            showdetailview: false,
            dialogMode: 'EDIT'
          }, this.onLoadRowsFromDialog() );
        }
      }
    }
  }

  onDialogUpdate( args, e ) {
    const layout = args.layout;
    const section = layout.section;
    const rowkey = section.rowkey;
    const allrows = clone( this.state.allrows );
    const newallrows = [];
    const currentitem = args.item;

    for( let index = 0;index < allrows.length; index++ ) {
      const allrow = allrows[ index ];
      if( allrow[ rowkey ] === currentitem[ rowkey ] ) {
        newallrows.push( currentitem );
      } else {
        newallrows.push( allrow );
      }
    }

    if( this._ismounted === true ){
      this.setState( {
        allrows: newallrows,
        currentitem: currentitem,
        showdetailview: false,
        dialogMode: '',
      }, this.onLoadRowsFromDialog() );
    }
  }

  onDialogDelete( args, e ) {
    const layout = args.layout;
    const section = layout.section;
    const rowkey = section.rowkey;
    const allrows = clone( this.state.allrows );
    const newallrows = [];
    const currentitem = args.item;

    for( let index = 0;index < allrows.length; index++ ) {
      const allrow = allrows[ index ];
      if( allrow[ rowkey ] !== currentitem[ rowkey ] ) {
        newallrows.push( allrow );
      }
    }

    if( this._ismounted === true ){
      this.setState( {
        allrows: newallrows,
        currentitem: {},
        showdetailview: false,
        dialogMode:'',
      }, this.onLoadRowsFromDialog() );
    }
  }

  //On Show the Dialog Grid
  onShowGrid( args, e ){

    if( args.data !== undefined ){
      if( args.data.length > 0 ){
        for( var index = 0; index < args.data.length; index++ ){
          args.data[index].mode = 'EDIT';
          args.data[index].changed = false;
        }
      }
    }

    if( this._ismounted === true ){
      this.setState( {
        gridtitle: args.title,
        gridrows: args.data,
        gridoptions: args.options,
        gridnewitem: args.newitem,
        showgriddialog: true
      } );
    }
  }

  // On Cancel the Dialog Grid
  onCancelGrid(){
    if( this._ismounted === true ){
      this.setState( {
        gridtitle: '',
        gridrows: [],
        showgriddialog: false,
        gridoptions: {}
      } );
    }
  }

  // On Save the Dialog Grid
  onSaveGrid( ){
    const layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const section = layout.section;
    const endpoint = section.endpoint;

    this.saveSubItem().then( ( payload ) => {
      let api = new EtelAPI( endpoint );

      const primarykey = payload.primarykey;
      const column = payload.column;

      api.getbyid( primarykey ).then( ( result ) => {

        const newitem = result[0];
        const rowindex = this.getParentRowIndex( primarykey );
        let allrows = this.state.allrows;
        allrows[ rowindex ] = newitem;
        const gridrows = newitem[ column ];

        if( this._ismounted === true ){
          this.setState( {
            currentitem: newitem,
            allrows: allrows,
            gridrows: gridrows,
            showgriddialog: false
          } );
        }

      } );

    } ).catch( ( error ) => {

      if( this._ismounted === true ){
        this.setState( {
          showgriddialog: false,
        } );
      }

    } );
  }

  // On Toggle Filter Flag, renders the proper size for the ListContainer grid
  onShowFilter( e ) {
    if( this._ismounted === true ){
      this.setState( {
        showfilters: e.target.value,
      }, this.windowResizeReRender );
    }
  }

  // Save the multiselect rows (Promise)
  saveMultiSelectRows( row ) {

    const getMultiSelectPayload = ( currentitem, column ) => {
      return this.getMultiSelectPayload( currentitem, column );
    };

    const createMultiSelectItem = ( endpoint, payload ) => new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( endpoint );
      api.insert( payload ).then( ( result ) => {
        resolve( result );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );

    const deleteMultiSelectItem = ( endpoint, keyValue ) => new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( endpoint );
      api.delete( keyValue ).then( ( result ) => {
        resolve( result );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );

    return new Promise( ( resolve, reject ) => {
      const layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
      const section = layout.section;
      const rowkey = section.rowkey;

      let fields = section.fields;

      if( fields === undefined && this.state.layoutselection !== undefined ){
        if( this.state.layoutselection.section.fields !== undefined ){
          fields = this.state.layoutselection.section.fields;
        }
      }

      let currentitem = this.state.currentitem;
      currentitem[rowkey] = row[rowkey];

      if( fields === undefined ){
        fields = [];
      } // Empty & undefined equivalent, this will allow the promise to not
      // proceed, and will not throw an error

      const callbacks = [];
      for( var fieldindex = 0; fieldindex < fields.length; fieldindex++ ) {
        const field = fields[ fieldindex ];
        if( field.type === 'multiselect' ) {
          const childpayload = getMultiSelectPayload( currentitem, field.column );
          if( childpayload.count > 0 ) {
            const childrows = childpayload.data;
            for( var childindex = 0; childindex < childrows.length; childindex++ ) {
              const childrow = childrows[ childindex ];
              if( childrow.STATUS === 'NEW' ) {
                callbacks.push( createMultiSelectItem( childpayload.endpoint, childrow.payload ) )
              }
              if( childrow.STATUS === 'DELETE' ) {
                let keyvalue = childrow.payload[ childpayload.rowkey ];
                callbacks.push( deleteMultiSelectItem( childpayload.endpoint, keyvalue ) );
              }
            }
          }
        }
      }

      if( callbacks.length > 0 ) {
        let all = () => Promise.all( callbacks ).then( ( results ) =>  {
          resolve( results );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
        all();
      } else {
        resolve( [] );
      }
    } );
  }

  // Save the child row (Promise)
  saveSubItem(){

    const layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const section = layout.section;
    const newitem = this.state.gridnewitem;
    const columnkey = newitem.columnkey;
    const rowkey = newitem.rowkey;
    const endpoint = newitem.endpoint;
    const currentitem = this.state.currentitem;
    let api = new EtelAPI( endpoint );
    let gridrows = this.state.gridrows;
    let parentRowKey = currentitem[ section.rowkey ];

    const createChildRowPayload = ( row, rowkey ) => {
      return this.createChildRowPayload( row, rowkey );
    };

    return new Promise( function( resolve, reject ) {

      let payload = {};

      for( var index = 0; index < gridrows.length; index++ ) {

        //** NEW ITEM **//
        if( gridrows[ index ].mode === 'NEW' ) {

          payload = createChildRowPayload( gridrows[ index ] );

          api.insert( payload ).then( ( result ) => {

            //** NO ACTIONS REQUIRED ON RESULT **//

          } ).catch( ( error ) => {

            reject( error );

          } );

        }

        //** UPDATE ITEM **/
        if( ( gridrows[ index ].mode === 'EDIT' ) && ( gridrows[ index ].changed === true ) ) {

          payload = createChildRowPayload( gridrows[ index ] );

          api.update( payload ).then( ( result ) => {

            //** NO ACTIONS REQUIRED ON RESULT **//

          } ).catch( ( error ) => {

            reject( error );

          } );

        }

        //** DELETE ITEM **//
        if( ( gridrows[ index ].mode === 'DELETE' ) && ( gridrows[ index ][ rowkey ] !== 0 ) ){

          api.delete( payload[ rowkey ] ).then( ( result ) => {

            //** NO ACTIONS REQUIRED ON RESULT **//

          } ).catch( ( error ) => {

            reject( error );

          } );
        }
      }

      payload = {
        'primarykey': parentRowKey,
        'column': columnkey
      };

      resolve( payload );

    } );
  }

  // Update the state based on the change child item
  onChangeSubItem( args, e ){
    const column = args.column;
    const rowindex = args.rowindex;
    let gridrows = this.state.gridrows;
    gridrows[ rowindex ][ column ] = e.target.value;
    gridrows[ rowindex ].changed = true;

    if( this._ismounted === true ){
      this.setState( { gridrows: gridrows } );
    }
  }

  // Show the edit screen
  onShowInputDialog( args, e ){
    if( this._ismounted === true ){
      this.setState( {
        gridtitle: args.gridtitle,
        options: args.options,
        showinputdialog: true
      } );
    }
  }

  // Hide the edit screen
  onHideInputDialog(){
    if( this._ismounted === true ){
      this.setState( {showinputdialog: false} );
    }
  }

  onExport( data ) {
    if( this._ismounted === true ){
      this.setState( {
        showexportdialog: true
      } );
    }
  }

  onCloseExportDialog( e ) {
    if( this._ismounted === true ){
      this.setState( {
        showexportdialog: false,
      } );
    }
  }

  onFileDialogConfirm( item ){
    let filelistinfo = this.cloneFileObj( item.filelistinfo );

    if( this._ismounted === true ){
      this.setState( {
        showfileuploaddialog: false,
        defdnis: item.defdnis,
        description: item.description,
        trueuploadfiles: filelistinfo,
        uploadfiles: filelistinfo,
        newallfiles: item.filelist,
      } );
    }
  }

  // Component Utility Functions
  onValidate( item ){
    return true;
  }

  // Create the input controls for detail view
  createEditControl( field, item, mode ) {
    let layout = this.state.layout === undefined ? this.props.layout : this.state.layout;

    if( this.state.multilayout === true ){
      if( this.state.layoutselection !== undefined ){
        layout = this.state.layoutselection;
      } else {
        layout = this.state.layoutoptions[0]['layout'];
      }
    }

    const section = layout.section;
    if( section.editmode === 'dialog' ) {
      return;
    }
    const currentitem = this.state.currentitem;
    let title = '';
    let type = 'label';
    let label = '';
    let column = '';
    let precision = 0;
    let cancreate = true;
    let canedit = true;
    let options = [];
    let newitem = {'title':''};
    let routes = {};
    let routekey = '';
    let groupname = '';
    let defdnis = '';
    let description = '';
    let uploadtype = 0;
    let placeholder = '';
    let maxLength = '';
    let dateFormat = '';
    let timeFormat = '';
    let isNew = mode === 'NEW' ? true : false;
    let defaultvalue = '';
    let disabled = false;
    let delimiter = '';

    // Date component selector
    let date_onNewValue = '';

    // Checks if its a modal
    let isProgramModal = this.state.showProgramsDialog;
    let padding_class = '';
    let checked = false;

    // Linkeditem
    let render_as;
    let option_fields;

    if( isProgramModal ){
      padding_class = 'list-container-detail-view-modal-left';
    }

    for( var key in Object.keys( field ) ) {

      let property = Object.keys( field )[key];

      if( property === 'type' ){
        type = field.type;
      }

      if( property === 'label' ){
        label = field.label;
      }

      if( property === 'column' ){
        column = field.column;
      }

      if( property === 'cancreate' ) {
        cancreate = field.cancreate;
      }

      if( property === 'canedit' ) {
        canedit = field.canedit;
      }

      if( property === 'precision' ){
        precision = field.precision;
      }

      if( property === 'options' ){
        options = field.options;
      }

      if( property === 'newitem' ){
        newitem = field.newitem;
      }

      if( property === 'title' ){
        title = field.title;
      }

      if( property === 'routes' ){
        routes = field.routes;
        routekey = routes.routekey;
      }

      if( property === 'placeholder' ){
        placeholder = field.placeholder;
      }

      if( property === 'groupname' ) {
        groupname = field.groupname;
      }

      if( property === 'defdnis' ) {
        defdnis = field.defdnis;
      }

      if( property === 'description' ) {
        description = field.description;
      }

      if( property === 'uploadtype' ) {
        uploadtype = parseInt( field.uploadtype, 10 );
      }

      if( property === 'dateFormat' ){
        dateFormat = field.dateFormat;
      }

      if( property === 'timeFormat' ){
        timeFormat = field.timeFormat;
      }

      if( property === 'maxLength' ) {
        maxLength = Number( field.maxLength );
      }

      if( property === 'checked' ) {
        checked = field.checked;
      }

      if( property === 'defaultvalue' ){
        defaultvalue = field.defaultvalue;
      }

      if( property === 'onNewValue' ){
        date_onNewValue = field.onNewValue;
      }

      if( property === 'render_as' ){
        render_as = field.render_as;
      }

      if( property === 'option_fields' ){
        option_fields = field.option_fields;
      }

      if( property === 'disabled' ){
        disabled = field.disabled;
      }

      if( property === 'delimiter' ){
        delimiter = field.delimiter;
      }
    }

    let onChangeItemEvent = this.onChangeItem.bind( this, field );
    let rowkey = 'list-container-input-row-' + type.toLowerCase() + '-' + column.toLowerCase();
    let value = item[column];

    let inputcontrol = [];

    if( value === undefined || value === null ){
      value = '';
    }

    if( typeof maxLength === 'number' ) {
      value = value.slice( 0, maxLength );
    }

    // Creates custom break label
    if( type === 'break' ){
      inputcontrol = (
        <div className='detail-view-row' key={rowkey}>
          <div className="detail-view-line-label">{label}</div>
          <div className='detail-view-line'></div>
        </div>
      );
    } else {

      // This was added to so that if a dropdown control is not editable
      // that the text value is displayed in a readonly fashion rather
      // than the numeric value. This is so that so you can set dropdowns
      // individually rather than the whole form being disabled from the
      // section settings.
      if( type === 'dropdown' && canedit === false && isNew === false ){
        const options = this.state.optionstore[routekey];
        if( options !== undefined ) {
          for( var index = 0;index < options.length; index++ ){
            if( parseInt( value,10 ) === parseInt( options[index].id,10 ) ) {
              value = options[index].text;
              break;
            }
          }
        }
      } else if( type === 'radioselection' && canedit === false && isNew === false ){
        if( options !== undefined ) {
          for( index = 0; index < options.length; index++ ){
            if( parseInt( value, 10 ) === parseInt( options[index].value, 10 ) ) {
              value = options[index].text;
              break;
            }
          }
        }
      } else if( type === 'datetime' && canedit === false && isNew === false ) {
        value = value.replace('T',' ').replace('Z',' ').trim();
        value = moment( value ).format( 'YYYY-MM-DD HH:mm:ss' );
      }

      //** CREATE DEFAULT LABEL **//
      inputcontrol = (
        <div className='detail-view-row' key={rowkey}>
          <span className={'detail-view-column ' + padding_class}>
            <span className='detail-view-content-label'>{label}</span>
          </span>
          <span className={'detail-view-column ' + padding_class}>
            <EditSectionLabel id={column} column={column} Text={value} width="100%" hilite />
          </span>
        </div>
      );
    }

    if( ( isNew === true && cancreate === true ) || ( isNew === false && canedit === true ) ) {
      //** CREATE TEXTBOX CONTROL **//
      if( type === 'textbox' ) {
        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column ' + padding_class}>
              <span className='detail-view-content-label'>
                {label}
              </span>
            </span>
            <span className={'detail-view-column ' + padding_class}>
              <EditSectionInput id={column} column={column} value={value} width="100%" onChanged={onChangeItemEvent} placeholder={placeholder} />
            </span>
          </div>
        );
      }

      //** CREATE NUMERIC CONTROL **//
      if( type === 'numerictextbox' ) {
        value = parseFloat( value ).toFixed( precision );
        if( value === 'NaN' ) {
          value = '';
        }
        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column ' + padding_class}>
              <span className='detail-view-content-label'>{label}</span>
            </span>
            <span className={'detail-view-column ' + padding_class}>
              <EditSectionInput id={column} column={column} value={value} width="100%" onChanged={onChangeItemEvent} />
            </span>
          </div>
        );
      }

      //** CREATE TEXTAREA CONTROL **//
      if( type === 'textarea' ){
        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column ' + padding_class}>
              <span className='detail-view-content-label'>{label}</span>
            </span>
            <span className={'detail-view-column ' + padding_class}>
              <EditSectionTextArea id={column} column={column} value={value} width="100%" onChanged={onChangeItemEvent} />
            </span>
          </div>
        );
      }

      //** CREATES (the only used in EOMReportSettings) TEXTAREA CONTROL **//
      if( type === 'textarea_eom' ){
        if( isNew === true ){
          inputcontrol = (
            <div className='detail-view-row' key={rowkey}>
              <span className={'detail-view-column ' + padding_class}>
                <span className='detail-view-content-label'>{label}</span>
              </span>
              <span className={'detail-view-column ' + padding_class}>
                <EditSectionTextArea id={column} column={column} value={value} width="100%" onChanged={onChangeItemEvent} />
              </span>
            </div>
          );
        } else {
          if( value !== '' && value !== undefined && value !== null ){
            inputcontrol = (
              <div className='detail-view-row' key={rowkey}>
                <span className={'detail-view-column ' + padding_class}>
                  <span className='detail-view-content-label'>{label}</span>
                </span>
                <span className={'detail-view-column ' + padding_class}>
                  <EditSectionTextArea id={column} column={column} value={value} width="100%" onChanged={onChangeItemEvent} />
                </span>
              </div>
            );
          } else {
            inputcontrol = undefined;
          }
        }
      }

      if( type === 'datetime' ) {
        if( value.includes('today') === true ) {
          value = moment().format( 'YYYY-MM-DD HH:mm:ss' );
        } else if( value.includes('yesterday') === true ) {
          value = moment().format( 'YYYY-MM-DD HH:mm:ss' );
          value = value.subtract(1,'d')
        }
      }
      //** CREATE DATE PICKER CONTROL **//
      if( type === 'date' ){
        // Get the value of the field, this value will use today, yesterday, + x (hours)
        if( date_onNewValue !== '' && value === '' ){
          const date_value = section.newitem[date_onNewValue].toLowerCase();
          let date_format = '';

          if( dateFormat !== false ){
            if( timeFormat !== false ){
              date_format = dateFormat + ' ' + timeFormat;
            } else {
              date_format = dateFormat;
            }
          // Default missing format
          } else {
            dateFormat = 'YYYYMMDD';
          }

          // Resolving today/yesterday values
          if( date_value.includes( 'today' ) ){

            const rm_today = new RegExp( 'today *' );
            let _today = date_value.replace( rm_today, '' );
            if( _today === '' ){
              value = moment().format( date_format );
            // Containes numeric values
            } else {
              // Will get the number of hours to remove or add
              _today = parseInt( _today.replace( ' ', '' ), 10 );
              value = moment().add( _today, 'hours' ).format( dateFormat );
            }

          } else if ( date_value.includes( 'yesterday' ) ){
            const rm_yesterday = new RegExp( 'yesterday *' );
            let _yesterday = date_value.replace( rm_yesterday, '' );
            if( _yesterday === '' ){
              value = moment().subtract( 24, 'hours' ).format( date_format );

            // Containes numeric values
            } else {
              // Will get the number of hours to remove or add
              _yesterday = parseInt( _yesterday.replace( ' ', '' ), 10 ) - 24;
              value = moment().add( _yesterday, 'hours' ).format( dateFormat );
            }
          }
          inputcontrol = (
            <div className='detail-view-row' key={rowkey}>
              <span className={'detail-view-column ' + padding_class}>
                <span className='detail-view-content-label'>{label}</span>
              </span>
              <span className={'detail-view-column ' + padding_class}>
                <EditSectionDateTime id={column} column={column} value={value} width="100%" onChange={onChangeItemEvent} dateFormat={dateFormat} timeFormat={timeFormat} />
              </span>
            </div>
          );
        } else {
          inputcontrol = (
            <div className='detail-view-row' key={rowkey}>
              <span className={'detail-view-column ' + padding_class}>
                <span className='detail-view-content-label'>{label}</span>
              </span>
              <span className={'detail-view-column ' + padding_class}>
                <EditSectionDateTime id={column} column={column} value={value} width="100%" onChange={onChangeItemEvent} dateFormat={dateFormat} timeFormat={timeFormat} />
              </span>
            </div>
          );
        }
      }

      //** CREATE DATE PICKER CONTROL **//
      if( type === 'time' ){
        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'list-container-detail-view-column ' + padding_class}>
              <span className='detail-view-content-label'>{label}</span>
            </span>
            <span className={'detail-view-column ' + padding_class}>
              <EditSectionDateTime id={column} column={column} value={value} width="100%" onChange={onChangeItemEvent} dateFormat={false} timeFormat={timeFormat} />
            </span>
          </div>
        );
      }

      //** CREATE DROPDOWN CONTROL **//
      if( type === 'dropdown' ){
        let store = this.state.optionstore;
        let options = [];
        if( ( routekey !== undefined ) || ( routekey !== '' ) ){
          options = store[routekey];
        }
        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column ' + padding_class}>
              <span className='detail-view-content-label'>{label}</span>
            </span>
            <span className={'detail-view-column ' + padding_class}>
              <EditSectionDropdown id={column} column={column} options={options} value={value} width="100%" onChanged={onChangeItemEvent} />
            </span>
          </div>
        );
      }

      //* CREATES A LINKED DROPDOWN **//
      if( type === 'linkeddropdown' ){
        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column ' + padding_class}>
              <span className='detail-view-content-label'>{label}</span>
            </span>
            <span className={'detail-view-column ' + padding_class}>
              <EditSectionLinkedDropdown id={column} column={column} options={this.state.pgm_voicefiles_linkedoptions} value={value} width="100%" onChanged={onChangeItemEvent} />
            </span>
          </div>
        );
      }

      //* CREATES A LINKED FIELD **//
      if( type === 'linkedfield' ){
        let opt_id;
        let opt_text;

        if( option_fields !== undefined ){
          opt_id = option_fields.value;
          opt_text = option_fields.text;
        }

        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column ' + padding_class}>
              <span className='detail-view-content-label'>{label}</span>
            </span>
            <span className={'detail-view-column ' + padding_class}>
              <EditSectionLinkedField id={column} column={column} readonly={disabled} render_as={render_as} route={routes} options={options} opt_id={opt_id} opt_text={opt_text} value={value} width="100%" onChanged={onChangeItemEvent} />
            </span>
          </div>
        );
      }


      //** CREATE STATIC DROPDOWN **//
      if( type === 'staticdropdown' ){
        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column ' + padding_class}>
              <span className='detail-view-content-label'>{label}</span>
            </span>
            <span className={'detail-view-column ' + padding_class}>
              <EditSectionDropdown id={column} column={column} options={options} value={value} width="100%" onChanged={onChangeItemEvent} />
            </span>
          </div>
        );
      }

      //** CREATE LAYOUTDROPDOWN **//
      if( type === 'layoutdropdown' ){
        let prop_value = value === '' ? defaultvalue : value;
        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column ' + padding_class}>
              <span className='detail-view-content-label'>{label}</span>
            </span>
            <span className={'detail-view-column ' + padding_class}>
              <EditLayoutDropdown id={column} column={column} options={options} value={prop_value} width="100%" onChanged={this.onChangeLayoutEvent} readonly={!isNew} />
            </span>
          </div>
        );
      }

      //** CREATE CHECKBOX COMPONENT **//
      if( type === 'checkbox' ){
        checked = value === 1 ? true : false;
        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column ' + padding_class}>
              <EditSectionCheckBox id={column} checked={checked} label={label} onChanged={onChangeItemEvent} />
            </span>
          </div>
        );
      }

      if ( type === 'inputdialog' ){
        let eventargs = {
          gridtitle: title,
          options: options
        };
        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column ' + padding_class}>
              <span className='detail-view-content-label'>{label}</span>
            </span>
            <span className={'detail-view-column ' + padding_class}>
              <button className='detail-view-column-button' onClick={this.onShowInputDialog.bind( this, eventargs )} >
                <span>&nbsp;&nbsp;</span>
                <span className='detail-view-content-label'>{label}</span>
              </button>
            </span>
          </div>
        );
      }

      //** CREATE MULTI-SELECT DROPDOWN **//
      if( type === 'multiselect' ) {
        let store = this.state.optionstore;
        let currentitem = this.state.currentitem;
        let values = [];
        let options = store[ routekey ];
        if( ( routekey !== undefined ) || ( routekey !== '' ) ){
          if( ( currentitem !== undefined ) && ( JSON.stringify( currentitem ) !== '{}' ) ) {
            if( currentitem[ routekey ] !== undefined ) {
              const currentitemvalues = currentitem[ routekey ];
              values = currentitemvalues.map( ( item ) => {
                let value = {};
                if( item['STATUS'] !== 'DELETE' ){
                  value['value'] = item[ routes.id ];
                  value['label'] = item[ routes.text ];
                  value['clearableValue'] = true;
                  return( value );
                } else {
                  return '';
                }
              } );
            }
          }
        }

        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column' + padding_class}>
              <span className='detail-view-content-label'>{label}</span>
            </span>
            <span className={'detail-view-column' + padding_class}>
              <Select name={column} placeholder={placeholder} value={values} options={options} multi={true} menuIsOpen={false} clearable={false} scrollMenuIntoView={false} onChange={onChangeItemEvent} />
            </span>
          </div>
        );
      }

      //** CREATE MULTI-SELECT INPUT (NOT A DROPDOWN) **//
      if( type === 'multiinput' ){
        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column' + padding_class}>
              <span className='detail-view-content-label'>{label}</span>
            </span>
            <span className={'detail-view-column' + padding_class}>
              <MultiInput name={column} placeholder={placeholder} delimiter={delimiter} display={value} onChanged={onChangeItemEvent} />
            </span>
          </div>
        );
      }

      //** CREATE DIALOG BUTTON CONTROL  **//
      if( type === 'dialog' ){
        let newrows = [];
        if( item[ column ] !== undefined ) {
          const itemrows = item[ column ];
          newrows = itemrows.map( ( itemrow ) => {
            let keys = Object.keys( itemrow );
            let newrow = {};
            for( var index = 0; index < keys.length; index++ ){
              let key = keys[ index ];
              newrow[ key ] = itemrow[ key ];
            }
            return( newrow );
          } );
        }
        let caption = label.toString() + ' (' + newrows.length.toString() + ')';
        let eventargs = {
          rowkey: section.rowkey,
          title: title,
          data: newrows,
          newitem: newitem,
          options: options
        };
        eventargs[ section.rowkey ] = item[ section.rowkey ];
        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column' + padding_class}>
              <span>&nbsp;</span>
            </span>
            <span className={'detail-view-column' + padding_class}>
              <button className='detail-view-column-button' onClick={this.onShowGrid.bind( this, eventargs )} >
                <i className=' icon-fontello-pencil-7' />
                <span>&nbsp;&nbsp;</span>
                <span className='list-container-detail-view-content-label' style={{'width':'200px'}}>{caption}</span>
              </button>
            </span>
          </div>
        );
      }

      //** CREATE FILEUPLOAD CONTROL **//
      if( type === 'fileupload' ) {
        const GroupName = currentitem[groupname];
        const DEFDNIS = currentitem[defdnis];
        const Description = currentitem[description];

        // Allows for multiple fileuploads to exist and not conflict, also clears the element
        // on new row selection because a new 'rowkey' is created on switching rows. The state is not remembered because only
        // 3 (leadgen as an example) can be rendered per key ('the key is unique, the state is not' -the react docs)
        const rowID = currentitem[section.rowkey];
        if( rowID === undefined ){
          rowkey = rowkey + 0;
        } else {
          rowkey = rowkey + rowID;
        }

        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column' + padding_class}>
              <span className='detail-view-content-label'>{label}</span>
            </span>
            <span className={'detail-view-column' + padding_class}>
              <FileUpload
                // Styles
                dropZoneStyleClass='fileupload-view'
                containerStyle='fileupload-container'
                containerStyleAfter='fileupload-container-after'
                text_style='fileupload-text'
                viewTextStyle='fileupload-text-view'

                // Attributes and args
                id={column} column={column} value={value}
                group_name={GroupName} defdnis={DEFDNIS} description={Description} upload_type={uploadtype} globalList={this.state.allfiles} onDropFile={this.onDropFileUpload} width="100%"/>
            </span>
          </div>
        );
      }

      //** CREATE RADIOSELECTION CONTROL **//
      if( type === 'radioselection' ){
        const values = currentitem;
        let default_value;

        // Checking that the value exist
        if( values[column] === undefined ){
          default_value = 0;
        } else {
          default_value = values[column];
        }

        if( typeof( default_value ) === 'boolean' ){
          default_value = default_value === true ? 1 : 0;
        }

        inputcontrol = (
          <div className='detail-view-row' key={rowkey}>
            <span className={'detail-view-column' + padding_class}>
              <span className='detail-view-content-label'>{label}</span>
            </span>
            <span className={'detail-view-column' + padding_class}>
              <RadioSelection options={options} onChanged={onChangeItemEvent} defaultOption={default_value}/>
            </span>
          </div>
        );
      }

    }

    return ( inputcontrol );
  }

  // Build the child payload for row gettting a child row
  createChildRowPayload( row, rowkey ){
    const newitem = this.state.gridnewitem;
    const newrow = newitem.newrow;
    const keys = Object.keys( newrow );
    let payload = {};

    if( row.mode === 'DELETE' ){
      payload[ rowkey ] = row[ rowkey ];
    } else {
      for( var index = 0; index < keys.length; index++ ){
        let key = keys[ index ];
        payload[ key ] = row[ key ];
      }
    }
    return payload;
  }

  // Get the current parent row index based on row key
  getParentRowIndex( parentRowKey ) {
    const allrowshash = this.state.allrowshash;
    let rowindex = -1;
    if( allrowshash !== undefined ){
      let foundhashrow = allrowshash[ parentRowKey ];
      if( foundhashrow !== undefined ){
        rowindex = foundhashrow.rowindex;
      }
    }
    return rowindex;
  }

  getFieldByColumnName( column ) {
    let layout = this.state.layout === undefined ? this.props.layout : this.state.layout;

    if( this.state.multilayout === true ){
      if( this.state.layoutselection !== undefined ){
        layout = this.state.layoutselection;
      } else {
        layout = this.state.layoutoptions[0]['layout'];
      }
    }

    const section = layout.section;
    const fields = section.fields;
    for( var index = 0; index < fields.length; index++ ){
      if( fields[ index ].column === column ) {
        const field = clone( fields[ index ] );
        return field;
      }
    }
    return undefined;
  }

  // Get the payload for backend based on current item selected
  getParentPayload( currentitem ) {
    let layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    if( this.state.multilayout === true ){
      if( this.state.layoutselection !== undefined ){
        layout = this.state.layoutselection;
      } else {
        layout = this.state.layoutoptions[0]['layout'];
      }
    }

    const section = layout.section;
    const newitem = section.newitem;

    let payload = {};
    if( currentitem !== undefined ){
      const keys = Object.keys( newitem );
      if( keys !== undefined ) {
        if( keys.length > 0 ) {
          for( var index = 0; index < keys.length; index++ ) {
            const key = keys[ index ];
            const field = this.getFieldByColumnName( key );
            if( field !== undefined ) {
              if( field.type.toLowerCase() !== 'multiselect' ) {
                const datatype = field.datatype;
                if( datatype !== undefined ) {
                  if( datatype.toLowerCase() === 'numeric' ) {
                    let precision = 6;
                    if( field.precision !== undefined ) {
                      precision = field.precision;
                    }
                    payload[ key ] = parseFloat( currentitem[ key ] ).toFixed( precision );
                  } else if( field.datatype.toLowerCase() === 'int' ) {
                    if( currentitem[ key ] === true ) {
                      payload[ key ] = 1;
                    } else if ( currentitem[ key ] === false ) {
                      payload[ key ] = 0;
                    } else {
                      payload[ key ] = parseInt( currentitem[ key ], 10 );
                    }
                  } else if( datatype.toLowerCase() === 'varchar' ) {
                    payload[ key ] = currentitem[ key ].toString();
                  } else if( datatype.toLowerCase() === 'nvarchar' ) {
                    payload[ key ] = currentitem[ key ].toString();
                  } else if( datatype.toLowerCase() === 'datetime' ) {
                    const format = field.dateFormat + ' ' + field.timeFormat;
                    payload[ key ] = moment( currentitem[ key ] ).format( format ).toString();
                  } else if( datatype.toLowerCase() === 'date' ) {
                    const format = field.dateFormat;
                    payload[ key ] = moment( currentitem[ key ] ).format( format ).toString();
                  } else if( datatype.toLowerCase() === 'time' ) {
                    const format = field.timeFormat;
                    payload[ key ] = moment( currentitem[ key ] ).format( format ).toString();
                  } else {
                    payload[ key ] = currentitem[ key ];
                  }
                } else {

                  alerts.CRITICAL( section.title, 'The appropriate datatype property in layout for the ' + key + ' field is missing.' );

                }
              }
            } else {

              payload[ key ] = currentitem[ key ];

            }
          }
        }
      }
    }
    return payload;
  }

  // Get the multi-select payload for the current item selected
  getMultiSelectPayload( currentitem, column ) {
    let childfield = this.getFieldByColumnName( column );
    let childrows = currentitem[ column ];
    let data = [];

    let payload = {
      endpoint: '',
      count: 0,
      data: []
    };

    if( ( childrows !== undefined ) && ( childfield !== undefined ) ) {
      if( childrows.constructor === Array || childrows.constructor === Object ){
        const newitem = childfield.newitem;
        const keys = Object.keys( newitem );
        for( var index = 0;index < childrows.length; index++ ) {
          const childrow = childrows[ index ];
          let dataitem = {};
          for( var keyindex = 0; keyindex < keys.length; keyindex++ ) {
            const key = keys[ keyindex ];

            if( dataitem['payload'] === undefined ){
              dataitem['payload'] = {};
            }

            if( dataitem['payload'][key] === undefined ) {
              dataitem['payload'][key]='';
            }

            dataitem['payload'][ key ] = childrow[ key ];
            if( newitem[ key ].searchtype === 'parent' ) {
              dataitem['payload'][ key ] = currentitem[ newitem[key].key ];
            }
          }
          dataitem['STATUS'] = childrow['STATUS'];
          data.push( dataitem );
        }
        payload['column'] = childfield.column;
        payload['rowkey'] = childfield.rowkey;
        payload['endpoint'] = childfield.endpoint;
        payload['count'] = data.length;
        payload['data'] = data;
      }
    }

    return payload;
  }

  onShowFileUploadDialog(){
    if( this._ismounted === true ){
      this.setState( { showfileuploaddialog: true } );
    }
  }

  //In order to preserve the state of uploadfiles for this component,
  //we need to create a custom clone of the object
  //This is so we do not unintentionally pass around references to components
  //and to keep this component's variable exclusive to this component
  cloneFileObj( obj ){
    let files = null;
    let newObj = {0:[],1:[],2:[]};
    for( var i = 0; i < 3; i++ ){
      files = obj[i];
      for( var j = 0; j < files.length; j++ ){
        newObj[i].push( files[j] );
      }
    }
    return newObj;
  }

  onHideFileUploadDialog(){
    //No change happened so send back the most recently saved dialog info
    let uploadRef = this.cloneFileObj( this.state.trueuploadfiles );
    if( this._ismounted === true ){
      this.setState( { showfileuploaddialog: false, uploadfiles: uploadRef } );
    }
  }

  // Component Render Functions
  onRenderGridHeader(){
    let layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const hasFilters = layout.filters === undefined ? false : true;
    const section = layout.section;
    const canExport = section.canexport === undefined ? false : section.canexport;
    const canSearch = section.cansearch === undefined ? true : section.cansearch;
    const showFuzzySearch = section.showfuzzysearch === undefined ? true : section.showfuzzysearch;
    let showAdvancedSearch = section.showadvancedsearch === undefined ? true : section.showadvancedsearch;

    if( showAdvancedSearch === true ) {
      showAdvancedSearch = hasFilters;
    }

    if( this.state.multilayout === true ){
      if( this.state.layoutselection !== undefined ){
        layout = this.state.layoutselection;
      } else {
        layout = this.state.layoutoptions[0]['layout'];
      }
    }

    const allrows = this.state.allrows;
    const filtered = this.state.filtered;
    const filteredRows = this.state.filteredrows;
    let pageSizeComponent = '';
    if( filtered === false ) {
      if( allrows !== undefined ) {
        if( allrows.length > 0 ) {
          pageSizeComponent = (
            <span className="grid-view-page-size">
              <PageSizeSelector totalRecords={allrows.length} onPageSizeChanged={this.onPageSizeChanged} />
            </span>
          );
        }
      }
    } else {
      if( filteredRows !== undefined ) {
        if( filteredRows.length > 0 ) {
          pageSizeComponent = (
            <span className="grid-view-page-size">
              <PageSizeSelector totalRecords={filteredRows.length} onPageSizeChanged={this.onPageSizeChanged} />
            </span>
          );
        }
      }
    }

    let searchControl = '';
    //* Build the advanced search button if the layout has filters **//
    const filters = layout.filters;
    let FiltersDefined = filters === undefined ? false : true;
    const search_value = this.state.search;
    if( canSearch === true ) {
      searchControl = (
        <span className="grid-view-search">
          <LoadableListSearch
            search={search_value}
            fuzzy={showFuzzySearch}
            advanced={FiltersDefined}
            onSearch={this.onSearchChanged}
            onShowAdvanced={this.onShowFilter} />
        </span>
      );
    }

    let exportControl = '';
    if( canExport === true ) {
      exportControl = (
        <span className="grid-view-export">
          <ListExport onExport={this.onExport} data={this.state.allrows} visible={!this.state.showdetailview} />
        </span>
      );
    }

    return (
      <span className="grid-view-header">
        {searchControl}
        <span className="grid-view-actions">
          { this.props.showAllRows !== true && pageSizeComponent }
          {exportControl}
        </span>
      </span>
    );
  }

  // Renders the filters fields
  onRenderFilters() {
    let layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const filters = layout.filters;
    const section = layout.section;
    const canbatchdelete = section.canbatchdelete === undefined ? false : section.canbatchdelete;

    if( this.state.multilayout === true ){
      if( this.state.layoutselection !== undefined ){
        layout = this.state.layoutselection;
        layout['filters'] = filters;
      } else {
        layout = this.state.layoutoptions[0]['layout'];
        layout['filters'] = filters;
      }
    }

    let showfilters = this.state.showfilters;
    const filterstore = this.state.filterstore;
    const showfuzzysearch = section.showfuzzysearch === undefined ? true : section.showfuzzysearch;

    if ( showfuzzysearch === false ) {
      showfilters = true;
    }

    return (
      <LoadableListFilter
        filters={filters}
        optionstore={filterstore}
        show={showfilters}
        onFilter={this.onFilterSearch}
        candelete={canbatchdelete}
        onBatchDelete={this.onBatchDelete}
      />
    );
  }

  // Changes the filters
  onFilterFieldChanged( e ) {
    const id = parseInt( e.target.id, 10 );
    let filters = this.state.filters;
    filters[id].value = e.target.value;

    if( this._ismounted === true ){
      this.setState( {
        filters: filters
      } );
    }
  }

  // Event occurs when search button is clicked
  onFilterSearch( filters, e ) {
    let { dispatch } = this.props;
    const layout = this.state.layout;
    const section = layout.section;
    const endpoint = section.endpoint;


    if( Object.keys( filters ).length !== 0 ) {
      dispatch( event( section.title, endpoint, 'ADVANCED SEARCH - ' + JSON.stringify( filters ) ) );
    } else {
      dispatch( event( section.title, endpoint, 'ADVANCED SEARCH CLEAR' ) );
    }

    this.buildListRows( filters );
  }

  // Renders all the rows, columns in the view
  onRenderGridBody( new_height ) {
    // Row and Column definition variables
    const showdetailview = this.state.showdetailview;
    const layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const tabs = layout.tabs;
    const section = layout.section;
    const headers = section.headers;
    const button = layout.newbutton;
    const caption = button.caption;
    const cancreate = section.cancreate;
    const canselect = section.canselect;
    const useclipboard = section.useclipboard === undefined ? false : section.useclipboard;
    const options = layout.options;

    // 0 -- Loading Rows...
    // 1 -- Search
    // 2 -- No rows available
    const loadingtext = section.loadingtext === undefined ? 0 : section.loadingtext;

    // Render variables
    let tabheaders = [];
    let tabheaderkey = '';
    let tabindex = 0;

    /* Displaying all rows in ListGridEditor, this is can be set by passing showAllRows to ListContainer. It will
       ommit the rendering of the dropdown item selector and will set the page view to all available rows */
    let pagesize = this.state.pagesize;
    let paging = true;
    if( this.props.showAllRows === true ){
      pagesize = this.state.allrows.length;
      paging = false;
    }

    // Create the Tabs
    tabheaders = tabs.map( ( tab ) => {
      tabindex +=1;
      let onSelectTabEvent = this.onSelectTab.bind( this, tabindex );
      tabheaderkey = 'tab-header-' + tabindex;
      tabs[tabindex-1]['eventKey'] = tabindex;
      let tabClassName = 'grid-view-tab-button';
      if( ( tabindex === this.state.selectedtab ) && ( tabs.length > 1 ) ) {
        tabClassName = 'grid-view-tab-button-selected';
      }
      return (
        <button className={tabClassName} key={tabheaderkey} onClick={onSelectTabEvent}>{tab.header}</button>
      );
    } );

    // Checks if the new button should be created
    let newbutton = '';
    const selectedtab = this.state.selectedtab;
    const editmode = section.editmode;



    // Only the parent can create new items, all else are created in relation to the parent
    if( selectedtab === 1 && editmode === 'dialog' ){
      if( cancreate === true && showdetailview === false ){
        newbutton = (
          <button className='grid-view-new-button' onClick={this.onNewItem}>
            <span className="grid-view-new-button-caption">New {caption}</span>
          </button> );
      }

      if( cancreate === true && showdetailview === true ){
        newbutton = (
          <button className='grid-view-new-button-disabled'>
            <span className='grid-view-new-button-caption'>New {caption}</span>
          </button> );
      }
    } else {
      if( editmode !== 'dialog' ){
        if( cancreate === true && showdetailview === false ){
          newbutton = (
            <button className='grid-view-new-button' onClick={this.onNewItem}>
              <span className="grid-view-new-button-caption">New {caption}</span>
            </button> );
        }

        if( cancreate === true && showdetailview === true ){
          newbutton = (
            <button className='grid-view-new-button-disabled'>
              <span className='grid-view-new-button-caption'>New {caption}</span>
            </button> );
        }
      }
    }

    // Renders a dropdown selection menu instead of a button
    if( canselect ){
      newbutton = ( <SelectionDropdownButton className="selection-dropdown-new-button btn btn-default" isDisabled={false} options={options} onSelect={this.DynamicRender} label={'New ' + caption}></SelectionDropdownButton> );
    } else {
      if( canselect !== undefined ){
        newbutton = ( <SelectionDropdownButton className='selection-dropdown-button-disable btn btn-default' isDisabled={true} options={options} label={'New'}></SelectionDropdownButton> );
      }
    }

    let rows = this.state.allrows;
    if( this.state.filtered === true ) {
      rows = this.state.filteredrows;
    }

    const dialogWidth = section.dialogWidth;
    const dialogHeight = section.dialogHeight;
    const dialogMode = this.state.dialogMode;
    const currentitem = this.state.currentitem;

    let View = (
      <LoadableListGrid
        loading={this.state.loading}
        displayvalue={loadingtext}
        layout={layout}
        layouts={this.state.layouts}
        headers={headers}
        data={rows}
        pagesize={pagesize}
        pageindex={this.state.pageindex}
        onRowClick={this.onEditItem}
        height={new_height}
        useclipboard={useclipboard}
        dialogWidth={dialogWidth}
        dialogHeight={dialogHeight}
        dialogMode={dialogMode}
        onChangeDialogMode={this.onChangeDialogMode}
        onDialogInsert={this.onDialogInsert}
        onDialogUpdate={this.onDialogUpdate}
        onDialogDelete={this.onDialogDelete}
        currentitem={currentitem}
        selectedtab={this.state.selectedtab}
        onCancelItemChange={ this.onCancelItemChangeFromDialog }
      />
    );

    if( section.editor === true ) {
      View = (
        <LoadableListGridEditor
          layout={ this.state.layout }
          rows={ rows }
          optionStore={ this.state.optionstore }
          paging={paging}
          pageSize={pagesize}
          pageIndex={this.state.pageindex}
          onDataSourceChanged={this.onDataSourceChanged}
          onFormatReadOnlyRow={this.props.onFormatReadOnlyRow}
          onFormatReadOnlyCell={this.props.onFormatReadOnlyCell}
          onFormatReadOnlyCellLabel={this.onFormatReadOnlyCellLabel}
          onUpdateItem={this.onUpdateItem}
          onIconClicked={this.onIconClicked}
          ReactGridStyles={this.props.ReactGridStyles}
          ReactGridBodyStyles={this.props.ReactGridBodyStyles}
          ReactGridNoFooter={this.props.ReactGridNoFooter}
          onSortGrid={this.props.onSortGrid}
        />
      );
    }

    // this.props.onRenderGridHeader will render a component above the tabs
    // if passed in.
    return (
      <span className="grid-view-body">
        <span className="grid-view-filters">
          {this.onRenderFilters()}
        </span>

        {this.props.onRenderGridHeader}

        <span className="grid-view-tabs">
          <span className="grid-view-new-button-area">
            {newbutton}
          </span>
          {tabheaders}
        </span>
        <span className="grid-view-rows">
          {View}
        </span>
      </span>
    );
  }

  // Resets the rows, so no state changes "stick" to the row views
  onCancelItemChangeFromDialog(){
    if( this._ismounted === true ){
      if( this.state.isfiltered ){
        this.setState( {
          dialogMode: '',
        }, this.onLoadRowsFromDialog() );
      } else {
        this.setState( {
          dialogMode: '',
        }, this.onLoadRowsFromDialog() );
      }
    }
  }

  onShowTest( e ) {
    const showdetailview = !this.state.showdetailview;
    if( this._ismounted === true ){
      this.setState( {
        showdetailview: showdetailview
      } );
    }
  }

  // Renders the footer, page index numbers, 'showing X to X of Y'
  onRenderGridFooter(){

    // Eliminates the pagination
    if( this.props.omitPagination && this.props.omitPagination === true ){
      return <span className="grid-view-pagination"></span>;

    // Full pagination
    } else {
      const allrows = this.state.allrows;
      const isfiltered = this.state.filtered;
      const filteredrows = this.state.filteredrows;
      let pagesize = this.state.pagesize;
      let layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
      let section = layout.section;
      let pageend = this.state.pageend;
      let maxpages = 6;

      // Display variables
      let pagetotal = 0;

      // Filtered (Searched) variables
      if( isfiltered === true ) {
        pagetotal = filteredrows.length;
      } else {
        pagetotal = allrows.length;
      }

      if( section.paginate !== undefined ){
        if( section.paginate === false ){
          pagesize = allrows.length;
          pageend = allrows.length;
          maxpages = 1;
        }
      }
      return (
        <span className="grid-view-footer">
          <span className="grid-view-page-position">
            <PagePositionLabel pagesize={pagesize} pagestart={this.state.pagestart} pageend={pageend} pagetotal={pagetotal} />
          </span>
          <span className="grid-view-pagination">
            {
              ( ( pagetotal/pagesize ) > 1 ) &&
              <span className="grid-view-pagination-label">Page</span>
            }
            <Pagination pageindex={this.state.pageindex} totalitems={pagetotal} maxitemsperpage={pagesize} maxpages={maxpages} onPageChanged={this.onPageChanged} />
          </span>
        </span>
      );
    }
  }

  // Render the detail view mode
  onRenderDetailView(){
    let layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    let section = layout.section;

    if( section.editmode === 'dialog' ) {
      return '';
    }

    // Sets the proper value for a multilayout (Accounting)
    if( this.state.multilayout === true ){
      const optkey = this.state.layoutkey;
      if( this.state.layoutselection !== undefined ){
        layout = this.state.layoutselection;
        section = this.state.layoutselection.section;
      } else {
        if( optkey !== undefined ){
          const options = this.state.layoutoptions;
          for( let i = 0; i < options.length; i++ ){
            if( options[i]['key'] === optkey ){
              layout = options[i]['layout'];
              section = options[i]['layout']['section'];
              break;
            }
          }
        }
      }
    }

    const cansaveandcontinue = section.cansaveandcontinue === undefined ? false : section.cansaveandcontinue;
    const candelete = section.candelete === undefined ? true : section.candelete;
    const fields = section.fields;
    const button = layout.newbutton;
    const currentitem = this.state.currentitem;
    const isNew = this.state.detailviewmode === 'NEW' ? true : false;
    const canenddate = section.canenddate === undefined ? false: section.canenddate; // Not as common as the other delete options {d. false}
    let caption = ( <span className='detail-view-header-caption'>New&nbsp;{button.caption}</span> );
    let cancelButton = ( <i className='detail-view-cancel-button icon-ikons-close' onClick={this.onCancelItem}/> );
    let deleteButton = '';

    let saveButton = (
      <button className='detail-view-save-button' onClick={this.onSaveItem}>
        {button.editCaption || 'Save'}
      </button>
    );

    if( cansaveandcontinue === true ) {
      saveButton = (
        <span className="detail-view-save-continue-section">
          <input className="detail-view-save-continue-toggle" type="checkbox" onChange={this.onSaveAndContinue} checked={this.state.allowsaveandcontinue} />
          &nbsp;&nbsp;<span className="detail-view-save-continue-label" >Another</span>
          <button className='detail-view-save-button' onClick={this.onSaveItem}>
            {button.editCaption || 'Save'}
          </button>
        </span>
      );
    }

    let inputcontrols = [];

    if( isNew === false ){
      caption = ( <span className='detail-view-header-caption'>Edit&nbsp;{button.caption}</span> );
      if( candelete === true ){
        deleteButton = (
          <button className='detail-view-delete-button' onClick={this.onDeleteItem}>
            <span className='detail-view-delete-button-caption'>Delete</span>
          </button> );
      } else {
        if( canenddate === true ){
          deleteButton = (
            <button className='detail-view-delete-button' onClick={this.onEndDateTime}>
              <span className="detail-view-delete-button-caption">End Now</span>
            </button> );
        }
      }
    }

    if( fields !== undefined ){

      if( fields.length > 0 ){

        inputcontrols = fields.map( ( field ) => {
          let inputcontrol = '';
          const cancreate = field.cancreate === undefined ? true : field.cancreate;
          const canedit = field.cancreate === undefined ? true : field.canedit;
          if( ( canedit === true ) || ( cancreate === true ) ) {
            inputcontrol = this.createEditControl( field, currentitem, this.state.detailviewmode );
          }
          return( inputcontrol );
        } );
      }
    }

    if( this.state.showdetailview === true ) {
      return (
        <span className="detail-view-content">
          <span className='detail-view-header'>
            {caption}
            {cancelButton}
          </span>
          <span className='detail-view-body'>
            {inputcontrols}
          </span>
          <span className='detail-view-footer'>
            {saveButton}
            {deleteButton}
          </span>
        </span>
      );
    } else {
      return ( <span style={{'display':'none'}}></span> );
    }
  }

  // Renders the DetailView for the Programs specifically
  onRenderDetailView_Programs(){
    const layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const section = layout.section;
    const fields = section.fields;
    const currentitem = this.state.currentitem;

    if( section.editmode === 'dialog' ) {
      return '';
    }

    // Settings render specific
    const route_type = parseInt( this.state.pgm_route_type, 10 );

    // Defaults for all controls (covers CANADIAN & US CELL & UTILITY)
    let valid_inputs = ['0','1','2','3', // (Breaks)
      'PDNIS', 'NAME', 'DESCRIPTION', 'ENTITY_ID', 'STATUS',
      'ACTIVE', 'ROUTING_TYPE_ID', 'IVR_FLOW_ID', 'PRIORITY',
      'DIAL_TO_NUMBER', 'COUNTRY_CODE', 'AD_TYPE_ID', 'DNIS_TYPE_ID',
      'DNIS_SUMMARY_ID', 'POST_REV', 'GEN_INVOICE', 'NOTES'];

    // Adding additional fields dependent on Routing Type
    if( route_type === 3 || route_type === 9 ||
       route_type === 8 || route_type === 6 ){
      // COUPONS & LEADGEN-MA & SECONDARY & MULTI AD
      valid_inputs.push( 'START_DATE' );
      valid_inputs.push( 'END_DATE' );
      valid_inputs.push( 'CALL_OR_SEAT_TARGET' );
      valid_inputs.push( 'MAX_CALLS_DAY' );
      valid_inputs.push( 'CHECK_NET' );
      valid_inputs.push( 'ALLOW_CELL' );
      valid_inputs.push( 'CALL_OR_SEAT' );
    }

    if( route_type === 1 || route_type === 7 ){
      // DNIS SET & LEADGEN
      valid_inputs.push( 'START_DATE' );
      valid_inputs.push( 'END_DATE' );
      valid_inputs.push( 'CHECK_NET' );
      valid_inputs.push( 'ALLOW_CELL' );
      valid_inputs.push( 'ROUTE_TO' );
      valid_inputs.push( 'ROUTE_TO_VALUE' );
      valid_inputs.push( 'BLOCKING_ANI_ROUTE' );
      valid_inputs.push( 'BLOCKING_PERM_BLOCK' );
    }

    // Used to check if extra tabs need to be shown or not
    const renderDetailType = this.state.detailviewmode;
    const currentkey = this.state.currentProgramTab;
    const show_route_to_value = this.state.pgm_route_to_value_show;

    // Settings
    let inputcontrols = [];
    let inputcontrols_expanded = [];

    // ONNET/OFFNET Variables
    let netcomponent = '';
    let show_numbers_tab = false;

    // SCHEDULE variables
    let schedule_visible = true;

    if( fields !== undefined ){
      if( fields.length > 0 ) {
        for( var fieldindex = 0; fieldindex < fields.length; fieldindex++ ) {
          const field = fields[ fieldindex ];
          if( field.type === 'break' ){
            if( this.state.expandProgramSettings ){
              inputcontrols_expanded.push( [] );
            }
          }
          let inputcontrol = this.createEditControl( field, currentitem, this.state.detailviewmode );
          if( valid_inputs.indexOf( field.column ) > -1 ){
            if( field.column === 'ROUTE_TO_VALUE' && show_route_to_value !== true ){
              inputcontrol = ( <div key={'route-to-value-hidden'}></div> );
            }
            inputcontrols.push( inputcontrol );
            if( this.state.expandProgramSettings ){
              inputcontrols_expanded[inputcontrols_expanded.length - 1].push( inputcontrol );
            }
          }
        }
      }
    }

    // Checking ON/OFFNET should be displayed
    if( currentitem.CHECK_NET === '1' || currentitem.CHECK_NET === 1 || currentitem.CHECK_NET === false ){
      netcomponent = 'OFFNET';
      show_numbers_tab = true;
    } else if( currentitem.CHECK_NET === '2' || currentitem.CHECK_NET === 2 || currentitem.CHECK_NET === true ) {
      netcomponent = 'ONNET';
      show_numbers_tab = true;
    } else {
      show_numbers_tab = false;
    }

    // Defaults to EDIT
    let render_visible = true;
    if( renderDetailType === undefined || renderDetailType === '' || renderDetailType === 'NEW' ){
      render_visible = false;
    }

    // Program Group Settings
    // Hides the Group Settings tab if the program is New or Pending
    let show_pgm_settings = false;
    if( currentitem['ACTIVE'] !== undefined ){
      // Only -200 (New) Programs do not allow for group settings to be altered
      // Once the program has a PDNIS, then it's internal can be altered.
      if( parseInt( currentitem['ACTIVE'], 10 ) !== -200 ){
        show_pgm_settings = true;
      }
    }

    let showASRSettings = false;
    if ( currentitem['IVR_FLOW_ID'] !== undefined ) {
      if ( parseInt( currentitem['IVR_FLOW_ID'], 10 ) === 201 ) {
        showASRSettings = true;
      }
    }

    //You cannot create a schedule using a UTILITY program so hide the schedules tab should a program be clicked on.
    if ( this.state.detailviewmode === 'NEW' ){
      schedule_visible = false;
    } else {
      if ( currentitem.ROUTING_TYPE_ID === 10 ){
        schedule_visible = false;
      } else {
        schedule_visible = true;
      }
    }

    return (
      <ProgramTabContainer onSelectTab={this.onChangedProgramsTab} activekey={currentkey}>
        <ProgramTabPanel>
          <ProgramTabPanelItem caption="Settings" width="100px">
            <LoadableProgramInputs currentItem={currentitem} Options={this.state.optionstore} onSave={this.onSaveItemFromPrograms} onCancel={this.onSaveItemFromPrograms} onCopyForward={this.ProgramCopyNew}/>
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="Schedule" width="100px" visible={schedule_visible}>
            <LoadableScheduleForm PDNIS={currentitem.PDNIS} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption={netcomponent + ' Numbers'} width="165px" visible={show_numbers_tab}>
            <LoadableWijmoOnOffNet currentItem={currentitem}/>
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="Fees" width="100px" visible={render_visible} >
            <LoadableProgramFeesForm currentitem={currentitem} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="Voice Files" width="150px" visible={show_pgm_settings}>
            <LoadableVoiceFilesForm currentitem={currentitem} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="Group Settings" width="150px" visible={show_pgm_settings}>
            <LoadableGroupSettingsForm currentItem={currentitem} onSave={this.onSaveItemFromPrograms} onCancel={this.onSaveItemFromPrograms} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="History" width="100px" visible={render_visible}>
            <LoadableProgramHistory currentItem={currentitem}/>
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="Links" width="100px" visible={render_visible}>
            <LoadableProgramLinks currentItem={currentitem} onSave={this.onSaveItemFromPrograms} onCancel={this.onSaveItemFromPrograms} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="ASR Interactions" width="150px" visible={showASRSettings}>
            <LoadableASRInteractions currentItem={currentitem} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="ASR Dialout Nums" width="175px" visible={showASRSettings}>
            <LoadableASRDialoutNumbers currentItem={currentitem} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="Dynamic Statements" width="175px" visible={true}>
            <LoadableProgramDynamicStatements currentItem={currentitem} />
          </ProgramTabPanelItem>
        </ProgramTabPanel>
      </ProgramTabContainer>
    );
  }

  // Recreates the program dialog and inserts the copy variables
  // sent over by the copy button
  ProgramCopyNew( e ){
    if( this._ismounted === true ){
      this.setState( {
        showProgramsDialog: true,
        currentProgramTab: 0,
        currentitem: e,
        detailviewmode: 'NEW'
      } );
    }
  }

  // Render the grid view class
  getGridViewClassName(){
    if( this.state.showdetailview === true ){
      return 'grid-view-hidden';
    }
    return 'grid-view';
  }

  // Render the detail view class
  getDetailViewClassname(){
    if( this.state.showdetailview === false ){
      return 'detail-view-hidden';
    }
    return 'detail-view';
  }

  // Handles the file upload in this container instead of internally in the component and
  //   links all 3 containers together, allows for item interaction to happen to all FileUpload
  //   components. FileUpload communicates with this control by sending back an 'action' that
  //   then this function handles.
  //   [ e -- is sent from a FileUpload as {'action': str, files: array of files}
  onDropFileUpload( e ){

    // This is defined by every callback event returned in FileUpload
    if( e['action'] !== 'none' ){

      // e states
      var files = e['files'];
      var action = e['action'];
      var uploadT;
      var current_upload_files;
      let current_files;

      // global state
      var uploadFiles = this.state['uploadfiles'];
      var all_file_names = [];

      // Index variables
      var x;
      var i;

      // Adds files to the global state (changes)
      if( action === 'add' ){

        // Which of the 3 FileUpload components sent back the file
        uploadT = files[0]['upload_type'];

        // Assigning the correct 'upload_type'
        uploadFiles[uploadT] = files;

        // Flatting out the array and collecting all the filenames found in each of the upload_types
        for( i = 0; i < 3; i++ ) {
          // Assigning to current upload_type group
          current_upload_files = uploadFiles[i];

          for( x = 0; x < current_upload_files.length; x++ ) {
            all_file_names.push( current_upload_files[x]['name'] );
          }
        }

        if( this._ismounted === true ){
          // Updating the state (blocking files that have names in this list)
          this.setState( { allfiles: all_file_names } );
        }

      // Removes files (on click event)
      } else {

        // If the length is 0, then the component has no more files to remove and is
        // returning an empty array -- this can happen if using only one FileUpload instead
        // of multiple ones (this edge case is handled here and the component will handle the
        // filtering)
        if( files.length !== 0 ){
          uploadT = files[0]['upload_type'];
          current_files = uploadFiles[uploadT];

          // New files
          let new_current = [];

          // Omitting the file on scan
          for( x = 0; x < current_files.length; x++ ) {
            if( files[0] !== current_files[x] ) {
              new_current.push( current_files[x] );
            }
          }

          // Assigning the new altered file
          uploadFiles[uploadT] = new_current;
        }

        // Recreating all the filenames from names found in each of the upload_types
        for( i = 0; i < 3; i++ ) {
          current_upload_files = uploadFiles[i];
          for( x = 0; x < current_upload_files.length; x++ ) {
            all_file_names.push( current_upload_files[x]['name'] );
          }
        }

        if( this._ismounted === true ){
          // Updating the state
          this.setState( { allfiles: all_file_names } );
        }
      }
    }
  }

  // Reads files drop in DropZone, part of the fileupload component
  readFile( file ){
    // File
    const reader = new FileReader();
    //let content = '';
    let filename = file.name;

    let self = this;

    // Fixes any undefined options in files
    let current_item = this.state.currentitem;

    // These can not be undefined (they are check before this call)
    let group_name = current_item['GROUP_NAME'];
    let defdnis = file.defdnis;
    let description = this.state.description;

    // Reading the entire content of the file as
    // text and setting where to store it's contents (reference)
    reader.readAsText( file );
    reader.onload = function ( e ) {
      // TODO: do we need this code really? LH 02/06/2018
      //content = e.target.result;
    };

    /*
      Sends the data over on completed read, missing columns are
      either filled in by the backend or lefts ommited because they
      are no longer used.
    */
    reader.onloadend = function( e ) {
      if( e.target.readyState === FileReader.DONE ) {
        var fd = new FormData();
        /*
          -- Enterprise.dbo.FILE_UPLOAD_CONTENTS
            [GROUP_NAME],[FILENAME],[NUMBER],[PROCESSED],[NOTES]
        */
        fd.append( 'GROUP_NAME', group_name );
        fd.append( 'FILENAME', filename );
        fd.append( 'NOTES', filename );

        /* Seperates files uploaded using the old way (10) from this control (11) */
        fd.append( 'STATUS', 11 );
        /*
          -- Enterprise.dbo.FILE_UPLOAD
            [GROUP_NAME],[UPLOAD_TYPE],[DEFDNIS],[DESCRIPTION],[FILENAME],[STATUS],[NOTES],[PAUSE_BETWEEN_STEPS],[COUNT_NEW],
            [COUNT_PROCESSED],[COUNT_ERROR],[COUNT_DUPS],[COUNT_TOTAL],[COUNT_OTHER],[COUNT_OTHER_DESC],[CreateOnDate],
            [CreateByUser],[DESTINATION],[REACT_USER_ID]
        */
        fd.append( 'UPLOAD_TYPE', file.upload_type );
        fd.append( 'DEFDNIS', defdnis );
        fd.append( 'DESCRIPTION', description );
        /*
          DECLARE @UPLOAD_DESTINATION_LEADGEN    INT = 1
          DECLARE @UPLOAD_DESTINATION_PROGRAM    INT = 2
          DECLARE @UPLOAD_DESTINATION_GLS        INT = 3
        */
        fd.append( 'DESTINATION', 1 );

        // The actual files content
        fd.append( 'FILE', reader.result );

        // Sending the file to the backend
        self.sendFile( fd, filename );
      }
    };
  }

  // Sends a file using axios
  sendFile( formdata, filename ){

    let api = new EtelAPI( 'files' );
    api.sendFile( formdata ).then( ( result ) => {
      let tmpstatus = this.state.fileuploadstatus;
      let id = result.data.results[0]['FILE_UPLOAD_ID'];
      let count = this.state.filecountsuccess;
      count = count + 1;

      //MAKE SURE THAT FILE_UPLOAD_ID IS RETURNED FROM THE STORED PROCEDURE
      tmpstatus[id] = {'FILE_UPLOAD_ID':id,'complete':true};
      if( this._ismounted === true ){
        this.setState( { fileuploadstatus: tmpstatus, filecountsuccess: count } );
      }

      return result;

    } ).catch( ( error ) => {
      let count = this.state.filecountfailure;
      count = count + 1;
      if( this._ismounted === true ){
        this.setState( { filecountfailure: count } );
      }
      return error;

    } );
  }

  // Loads a layout based on the selection from a dropdown
  onChangeLayoutEvent( e ){
    const key = parseInt( e.target.value, 10 );
    let layoutselection = undefined;

    if( isNaN( key ) !== true ){
      const options = this.state.layoutoptions;

      if( options.length > 0 ){
        for( let i = 0; i < options.length; i++ ){
          if( options[i]['key'] === key ){
            layoutselection = options[i]['layout'];
            break;
          }
        }
      }

      let layout_newitem = layoutselection['section']['newitem'];
      let newitem = clone( this.state.currentitem );
      const newfieldkeys = Object.keys( layout_newitem );

      for( let i = 0; i < newfieldkeys.length; i++ ){
        let key = newfieldkeys[i];
        newitem[key] = layout_newitem[key];
      }

      if( this._ismounted === true ){
        this.setState( {
          layoutkey: key,
          layoutselection: layoutselection,
          detailviewmode: 'NEW',
          currentitem: newitem
        } );
      }
    }
  }

  // Sets the END_TIME to today when clicked
  onEndDateTime() {
    let cur_item = this.state.currentitem;
    cur_item['END_DATE'] = parseInt( moment().format( 'YYYYMMDD' ), 10 );
    if( this._ismounted === true ){
      this.setState( {
        currentitem: cur_item
      } );
    }
  }

  //Hide the save dialog
  onHideSaveDialog() {
    if( this._ismounted === true ){
      this.setState( {
        showsavedialog: false,
        updatecomplete: false,
        insertcomplete: false,
        uploadcomplete: false,
        dialogtitle: '',
        filecountsuccess: 0,
        filecountfailure: 0,
        filecheck: false,
        fileuploadstatus: {'TOTAL_COUNT':0}
      } );
    }
  }

  //Show the save dialog
  onShowSaveDialog() {
    const leadgen_name = this.state.currentitem.GROUP_NAME;
    if( this._ismounted === true ){
      this.setState( {
        showsavedialog: true,
        filecheck: true,
        dialogtitle: 'Uploaded Files For ' + leadgen_name,
      } );
    }
  }

  // Event that fires when batch delete button clcked from ListFilter component
  onBatchDelete( e ) {
    if( this._ismounted === true ){
      this.setState( {
        showbatchdeletedialog: true
      } );
    }
  }

  onBatchDeleteError( exception ) {
    const { dispatch } = this.props;
    const bugsnag = this.props.bugsnag;
    const alerts = new Alerts( bugsnag, dispatch );
    alerts.CRITICAL( 'Batch Delete', exception );
    if( this._ismounted === true ){
      this.setState( {
        showbatchdeletedialog: false,
      } );
    }
  }

  onBatchDeleteConfirm( e ) {
    const { dispatch } = this.props;
    const bugsnag = this.props.bugsnag;
    const alerts = new Alerts( bugsnag, dispatch );
    alerts.SUCCESS( 'Batch Delete', 'Successfully deleted record(s)!' );
    this.onFilterSearch( this.state.filters, e );

    if( this._ismounted === true ){
      this.setState( {
        showbatchdeletedialog: false
      } );
    }
  }

  // Event fired off when BatchDeleteDialog is closed
  onCloseBatchDelete( e ) {
    if( this._ismounted === true ){
      this.setState( {
        showbatchdeletedialog: false
      } );
    }
  }

  render() {
    let layout = this.state.layout === undefined ? this.props.layout : this.state.layout;
    const section = layout.section;
    const headers = section.headers;
    if( this.state.multilayout === true ){
      if( this.state.layoutselection !== undefined ){
        layout = this.state.layoutselection;
      } else {
        layout = this.state.layoutoptions[0]['layout'];
      }
    }

    let page_title = '';
    if( this.state.layout ){
      page_title = this.state.layout.section.title;
    }

    const showdeletedialog = this.state.showdeletedialog;
    const showgriddialog = this.state.showgriddialog;
    const showinputdialog = this.state.showinputdialog;
    const showsavedialog = this.state.showsavedialog;
    const showexportdialog = this.state.showexportdialog;
    const showfileuploaddialog = this.state.showfileuploaddialog;
    const showbatchdeletedialog = this.state.showbatchdeletedialog;

    if( this.state.loading === false ) {

      const showoverlay = showdeletedialog === true ||
                          showgriddialog === true ||
                          this.state.showProgramsDialog === true ||
                          showfileuploaddialog === true ||
                          showexportdialog === true ||
                          showbatchdeletedialog === true;

      // What the Programs caption should be
      let modalProgramCaption = 'New Program';
      if( this.state.detailviewmode === 'EDIT' && this.state.showProgramsDialog ) {
        modalProgramCaption = 'Program Settings for ' + this.state.currentitem.PDNIS + ' | ' + this.state.currentitem.PROGRAM_NAME;
      }
      
      return (
        <span>
          <RouteTitle title={page_title} />
          <span className="list-container">
            <span id="ListContainerGridView" className={this.getGridViewClassName()}>
              {this.onRenderGridHeader()}
              <span className='list-container-grid-view-content'>
                {this.onRenderGridBody( this.state.render_grid_view_body_height )}
              </span>
              {this.onRenderGridFooter()}
              <span className="list-container-overlay"></span>
            </span>
            <span id="ListContainerDetailView" className={this.getDetailViewClassname()}>
              {this.onRenderDetailView()}
            </span>
          </span>
          <DeleteItemDialog layout={layout} show={showdeletedialog} onCancel={this.onCancelDelete} onConfirm={this.onConfirmDelete} />
          <ChildRowsDialog show={showgriddialog} layout={layout} optionstore={this.state.optionstore} title={this.state.gridtitle} headers={this.state.gridoptions.fields} rows={this.state.gridrows} newitem={this.state.gridnewitem} onNew={this.onNewSubItem} onDelete={this.onDeleteSubItem} onCancel={this.onCancelGrid} onSave={this.onSaveGrid} onChange={this.onChangeSubItem}/>
          <InputDialog show={showinputdialog} layout={layout} optionstore={this.state.optionstore} onCancel={this.onHideInputDialog} title={this.state.gridtitle} options={this.state.options} data={this.state.currentitem}/>
          <LeadgenFileDialog show={showsavedialog} currentitem={this.state.currentitem} dialogtitle={this.state.dialogtitle} layout={layout} onCancel={this.onHideSaveDialog} insertDone={this.state.insertcomplete} updateDone={this.state.updatecomplete} fileuploadstatus={this.state.fileuploadstatus} filecountsuccess={this.state.filecountsuccess} filecheck={this.state.filecheck} filecountfailure={this.state.filecountfailure} />
          <FileUploadDialog show={showfileuploaddialog} onCancel={this.onHideFileUploadDialog} currentitem={this.state.currentitem} onConfirm={this.onFileDialogConfirm} defdnisValue={this.state.defdnis} descriptionValue={this.state.description} allfiles={this.state.newallfiles} optionstore={this.state.optionstore} uploadfiles={this.state.uploadfiles} />
          <ProgramDialog onCancel={this.onCloseItemFromPrograms} width={95} height={95} show={this.state.showProgramsDialog} caption={modalProgramCaption} currenttab={this.state.currentProgramTab}>
            {this.onRenderDetailView_Programs()}
          </ProgramDialog>
          <LoadableListExportDialog show={showexportdialog} width={20} height={30} onClose={this.onCloseExportDialog} from={section.title} headers={headers} data={this.state.allrows} />
          <BatchDeleteDialog show={showbatchdeletedialog} onClose={this.onCloseBatchDelete} from={section.title} endpoint={section.endpoint} searchfilter={this.state.searchfilters} onBatchDeleteError={this.onBatchDeleteError} onBatchDeleteConfirm={this.onBatchDeleteConfirm} />
          <Overlay show={showoverlay} />
        </span>
      );
    } else {
      let alertMessage = 'Loading ' + this.state.title + ' List...';
      return (
        <span>
          {alertMessage}
          <RouteTitle title={page_title} />
        </span>
      );
    }
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user,
        google: store.google.ReactGA
      };
    }
  )( ListContainer ) );


// WEBPACK FOOTER //
// ./src/presentation/ListContainer.js